const translations = {};

translations["MSG_GUIDE"] = "指南";
translations["MSG_NETWORK_ERROR_MESSAGE"] = "無法顯示頁面。\n請再試一次。";
translations["MSG_APP_ALL"] = "全部";
translations["MSG_APP_BANNER_TITLE"] = "『樂學拼圖』App版";
translations["MSG_APP_BANNER_SUBTITLE"] = "~ 為孩子們打造的有趣程式設計教育 ~";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "安裝";
translations["MSG_APP_BANNER_SHOW_BTN"] = "顯示";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "正在將應用程式更新至最新版本。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "應用程式有新版本可用。\n需要更新才能使用最新功能。\n更新將很快完成。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "請輸入 6 個字元或以上的密碼。";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "密碼不符。";
translations["MSG_SIGN_IN_BTN"] = "登入";
translations["MSG_SIGN_UP_BTN"] = "註冊";
translations["MSG_SIGN_IN_WITH_APPLE"] = "使用 Apple 繼續";
translations["MSG_SIGN_UP_WITH_APPLE"] = "使用 Apple 繼續";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "使用 Google 繼續";
translations["MSG_SIGN_IN_WITH_MAIL"] = "使用電子郵件登入";
translations["MSG_SIGN_UP_WITH_MAIL"] = "使用電子郵件註冊";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "沒有帳戶？註冊";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "已有帳戶？登入";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "請輸入密碼";
translations["MSG_SIGN_LOGIN_FAILED"] = "登入失敗。請檢查您的電子郵件地址和密碼。";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "密碼不匹配";
translations["MSG_SIGN_UP_FAILED"] = "帳戶建立失敗。請重試。";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "請輸入您的電子郵件地址";
translations["MSG_SIGN_EMAIL_INVALID"] = "請輸入有效的電子郵件地址";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] = "密碼重置郵件發送失敗。請重試。";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※我們將向您註冊的電子郵件地址發送密碼重置連結。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "發送重置郵件";
translations["MSG_SIGN_EMAIL_SENT"] = "郵件已發送";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] = "密碼重置連結已發送。\n請檢查您的郵件。";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "返回登入";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "請輸入10個字元以內的姓名";
translations["MSG_USER_NAME_REQUIRED"] = "請輸入姓名";
translations["MSG_USER_LATEST"] = "最新";
translations["MSG_USER_LIST"] = "用戶列表";
translations["MSG_USER_START_LEARNING_MESSAGE"] = "為了開始學習，\n請先建立帳戶。";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "新增兒童帳戶";
translations["MSG_USER_START"] = "開始";
translations["MSG_SIGN_USER_MAIL"] = "電子郵件地址";
translations["MSG_SIGN_USER_PASSWORD"] = "密碼";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "重新輸入密碼";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "登入成功。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "帳戶註冊成功。";
// ReAuth
translations["MSG_REAUTH_TITLE"] = "身份驗證";
translations["MSG_REAUTH_SSO_MESSAGE"] = "請再次登入以繼續";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] = "將向以下郵箱發送密碼重置郵件";
translations["MSG_REAUTH_BACK"] = "返回";
translations["MSG_BTN_LATER"] = "稍後";
translations["MSG_BTN_CLOSE"] = "關閉";

// Restricted Feature Dialog (統一版)
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "無法玩課程";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "無法製作應用";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "「%{plan}」最多可創建%{limit}個應用。\n選擇其他方案後可創建更多，<br>請詢問家長。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "無法添加玩家";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "「%{plan}」最多可添加%{limit}個用戶。\n選擇其他方案後可添加更多，<br>請詢問家長。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "無法傳送訊息";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "「%{plan}」每天可傳送%{limit}次。\n選擇其他方案後可傳送更多，<br>請詢問家長。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "無法製作圖像";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "「%{plan}」每天可製作%{limit}次。\n選擇其他方案後可製作更多，<br>請詢問家長。";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "無法儲存素材";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "「%{plan}」最多可儲存%{limit}的素材。\n選擇其他方案後可儲存更多，<br>請詢問家長。";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "選擇方案";

// Upgrade Promotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "升級你的計畫，享受更多！";
translations["MSG_UPGRADE_MODAL_TITLE"] = "選擇方案";
translations["MSG_UPGRADE_MODAL_SUBTITLE"] = "請根據孩子的使用情況選擇合適的方案";
translations["MSG_UPGRADE_MODAL_CURRENT_PLAN"] = "目前方案";
translations["MSG_UPGRADE_PROMOTION_RECOMMENDED"] = "推薦";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "計畫";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "兒童用戶數";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8人";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "作品數";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10個";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10個";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AI圖像";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "每天1次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "每天2次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "每天10次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "無限制\n（同時3張）";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "AI助手";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "每天4次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "每天8次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "無限制";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "無限制";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "資料儲存容量";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_PLAN_CHANGE_BTN"] = "變更方案";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "變更";
translations["MSG_UPGRADE_PROMOTION_TRIAL_DESCRIPTION"] = "註冊帳戶後可訂閱付費計畫";
translations["MSG_UPGRADE_PROMOTION_FREE_DESCRIPTION"] = "您可以在家長頁面更改計畫";
translations["MSG_UPGRADE_PROMOTION_LATER_BTN"] = "稍後";
translations["MSG_UPGRADE_PROMOTION_SIGNUP_BTN"] = "註冊帳戶";
translations["MSG_UPGRADE_PROMOTION_UPGRADE_BTN"] = "前往家長頁面";
translations["MSG_UPGRADE_PROMOTION_BTN_REGISTER"] = "註冊";
translations["MSG_UPGRADE_PROMOTION_BTN_PURCHASE"] = "購買";

translations["MSG_SIGN_IN_FAILED_TITLE"] = "登入失敗";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "電子郵件地址或密碼不正確。";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "忘記密碼？";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "重設密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "目前密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "確認密碼";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "密碼變更成功。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] = "輸入的密碼不正確。";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] = "此電子郵件地址已被使用。";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "家長";

translations["MSG_DATETIME_PERIOD"] = "期間";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "最近";
// 台灣常用格式
translations["MSG_DATETIME_FORMAT_HOUR"] = "時";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "分";

translations["MSG_INEXUS_OFFICIAL"] = "樂學拼圖";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "樂學拼圖 支援";
translations["MSG_AI_CHAT_SESSION_START"] = "新的對話";
translations["MSG_AI_CHAT_SESSION_END"] = "對話結束";
translations["MSG_REVIEW_RATING_TITLE"] = "請告訴我們\n'樂學拼圖'\n的評價！";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "意見箱";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "傳送";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "傳送意見回饋";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "非常\n感謝您！";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] = "我們期待您繼續支持\n'樂學拼圖'。";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "整個應用程式";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "'透過課程學習'";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "'自由創作'";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "沒有抱怨";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "不知道\n如何使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "難以使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "太難";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "太簡單";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "關卡\n太多";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "關卡\n太少";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "無法\n順利創作";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "難以\n使用";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "在此自由填寫";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "新增";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "切換使用者";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "切換使用者？";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] = "切換到「%{name}」。";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "已切換使用者。";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "切換使用者失敗。";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "無法新增使用者";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "當前方案最多可創建%{limit}個用戶\n如需添加新用戶，請刪除已有用戶";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_TITLE"] = "這裡無法新增";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_MESSAGE"] =
  "・只有家長才能新增玩家。\n・如需新增玩家，請讓家長在家長頁面進行新增。";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "更多";
translations["MSG_USER_PROFILE_USER_STATUS"] = "狀態";
translations["MSG_USER_SELECTION_PROMPT"] = "請選擇玩家";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "姓名%{random}";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "暱稱";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "輸入暱稱";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "給自己取個名字吧";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "性別";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "男性";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "女性";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "無";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "生日";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "已完成\n課程";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "已建立\n應用程式";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "已發佈\n應用程式";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] = "收到的\n讚數";
translations["MSG_USER_PROFILE_STATUS_DAYS_SINCE_JOIN"] = "加入\n天數";
translations["MSG_USER_PROFILE_STATUS_DAYS_UNIT"] = "%{count}天";
translations["MSG_USER_PROFILE_STATUS_PLAN"] = "方案";
translations["MSG_USER_TAB_PROGRESS"] = "學習";
translations["MSG_USER_TAB_STOCK"] = "物品";
translations["MSG_USER_TAB_PLAN"] = "方案";
translations["MSG_USER_PLAN_CURRENT"] = "使用中";
translations["MSG_USER_PLAN_USAGE"] = "使用量";
translations["MSG_USER_PLAN_CHANGE"] = "變更方案";
translations["MSG_USER_PLAN_PROJECTS"] = "作品數量";
translations["MSG_USER_PLAN_AI_CHAT"] = "AI聊天";
translations["MSG_USER_PLAN_AI_IMAGE"] = "AI圖像";
translations["MSG_USER_PLAN_UNLIMITED"] = "無限制";
translations["MSG_USER_PLAN_HERO_INCLUDED"] = "方案包含的內容";
translations["MSG_USER_PLAN_HERO_TAGLINE_TRIAL"] = "試試看吧！";
translations["MSG_USER_PLAN_HERO_TAGLINE_FREE"] = "免費玩";
translations["MSG_USER_PLAN_HERO_TAGLINE_STANDARD"] = "製作更多";
translations["MSG_USER_PLAN_HERO_TAGLINE_PREMIUM"] = "創作無限！";
translations["MSG_USER_PLAN_HERO_TAGLINE_BUILDER"] = "還能製作地圖！";
translations["MSG_USER_PLAN_HERO_TAGLINE_EDUCATION"] = "一起學習";
translations["MSG_USER_PLAN_UPGRADE_CARD_TITLE"] = "還有更多有趣的方案";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NOW"] = "現在";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NEXT"] = "升級後";
translations["MSG_USER_PLAN_BILLING_MONTHLY"] = "按月";
translations["MSG_USER_PLAN_BILLING_ANNUAL"] = "按年";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL"] = "省2個月！";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL_BADGE"] = "省2個月！";
translations["MSG_USER_PLAN_PRICE_PER_MONTH"] = "/月";
translations["MSG_USER_PLAN_PRICE_PER_YEAR"] = "/年";
translations["MSG_USER_PLAN_UPGRADE_BTN"] = "立即升級";
translations["MSG_USER_PLAN_VIEW_ALL_PLANS"] = "查看全部方案";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_TITLE"] = "需要更新應用";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_MESSAGE"] = "請升級到最新版本";
translations["MSG_USER_PLAN_PURCHASE_SUCCESS"] = "升級成功！";
translations["MSG_USER_PLAN_PURCHASE_ERROR"] = "出錯了，請再試一次";
translations["MSG_USER_PLAN_AI_IMAGE_PER_REQUEST"] = "1次生成";
translations["MSG_USER_PLAN_AI_IMAGE_CREATE_COUNT"] = "生成次數";
translations["MSG_USER_PLAN_AI_IMAGE_SIMULTANEOUS_COUNT"] = "單次張數";
translations["MSG_USER_PLAN_ASSETS"] = "儲存空間";
translations["MSG_USER_PLAN_SUBTAB_CURRENT"] = "使用\n狀況";
translations["MSG_USER_PLAN_SUBTAB_PURCHASE"] = "購買\n方案";
translations["MSG_USER_PLAN_COMPARE_HEADER_CURRENT"] = "目前";
translations["MSG_USER_PLAN_INACTIVE_NOTICE"] = "可以使用所有功能！";
translations["MSG_USER_PLAN_CARD_CURRENT_BADGE"] = "目前方案";
translations["MSG_USER_PLAN_PRICE_FREE"] = "¥0";
translations["MSG_USER_PLAN_GOTO_PURCHASE"] = "升級方案";
translations["MSG_USER_PLAN_BUY_BTN"] = "選擇此方案";
translations["MSG_USER_PLAN_REGISTER_BTN"] = "註冊";
translations["MSG_USER_PLAN_COMPARE_SAME"] = "相同";
translations["MSG_USER_PLAN_COMPARE_UNLOCK"] = "可以使用！";
translations["MSG_USER_PLAN_TIMES_SUFFIX"] = "倍";
translations["MSG_USER_PLAN_USAGE_CARD_TITLE"] = "使用狀況";
translations["MSG_USER_PLAN_USAGE_CARD_SUBTITLE"] = "今日使用情況";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_TITLE"] = "升級後";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_SUBTITLE"] = "可以做更多的事情！";
translations["MSG_USER_PLAN_UNIT_PIECES"] = "個";
translations["MSG_USER_PLAN_UNIT_TIMES"] = "次";
translations["MSG_USER_PLAN_UNIT_SHEETS"] = "張";
translations["MSG_USER_PLAN_PERIOD_DAILY"] = "每日";
translations["MSG_USER_PROFILE_PROGRESS"] = "紀錄";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "新！";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "等級";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "透過課程\n學習";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_BTN"] = "已通關\n課程";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "天";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "已完成數量";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "自由\n創作";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_BTN"] = "我的\n作品";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] = "總計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] = "總計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] = "讚";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] = "訪客";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] = "讚數";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] = "還沒有作品";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY_DESC"] =
  "在「自由創作」中玩耍後，這裡會顯示";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] = "前往「自由創作」";
translations["MSG_USER_PROFILE_INFO"] = "我";
translations["MSG_USER_PROFILE_ICON_BTN"] = "變更圖示";
translations["MSG_USER_PROFILE_CASE_BTN"] = "變更外殼";
translations["MSG_USER_PROFILE_STOCK"] = "素材";
translations["MSG_USER_PROFILE_SETTING"] = "設定";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "註冊失敗。";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] = "包含無法使用的字元或文字。請再試一次。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] = "註冊失敗。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "包含無法使用的字元或文字。請再試一次。";
translations["MSG_USER_PROFILE_MESSAGE"] = "郵件";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type} 詢問";
translations["MSG_USER_PROFILE_MESSAGE_REPORT_TITLE"] = "向營運的回報";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "感謝您的詢問！\n請在下方的輸入欄位中填寫您的問題。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = " 加入了。";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "傳送";
translations["MSG_USER_PROFILE_MESSAGE_MENU"] = "選單";

// Official welcome messages (dynamic index 0..3)
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] = "%{name}，歡迎來到 '樂學拼圖'！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "在 '樂學拼圖' 中，您可以邊玩有趣的拼圖邊學習程式設計。\n首先，請從「透過課程學習」開始，依序學習如何遊玩和學習！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "當您大致了解演算法和程式設計方法後，請嘗試在「自由創作」中隨心所欲地建立您自己的應用程式。";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] = "來試試 '樂學拼圖' 吧！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = " 傳送了評價。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] = "感謝您的評價！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] = "感謝您的意見回饋！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "意見回饋";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] = "・自我介紹：";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "在此自由填寫";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] = '已發佈應用程式 "%{name}"。';

translations["MSG_USER_DASHBOARD_TITLE"] = "儀表板";
translations["MSG_USER_DASHBOARD_VIEW_FULL_PAGE"] = "打開\n我的頁面";
translations["MSG_USER_DASHBOARD_UNREAD"] = "未讀";
translations["MSG_USER_DASHBOARD_NO_UNREAD"] = "沒有新訊息";
translations["MSG_DASHBOARD_SWITCH_PLAYER"] = "切換\n玩家";
translations["MSG_DASHBOARD_ADD_PLAYER"] = "新增\n玩家";
translations["MSG_DASHBOARD_CHANGE_PLAN"] = "變更\n方案";
translations["MSG_DASHBOARD_PLAN_USAGE_TITLE"] = "使用情況";
translations["MSG_DASHBOARD_QUICK_SETTINGS_TITLE"] = "快速設定";
translations["MSG_DASHBOARD_SETTING_LANGUAGE"] = "語言";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_CHAT"] = "AI聊天";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_IMAGE"] = "AI圖片";
translations["MSG_DASHBOARD_PLAN_USAGE_PROJECTS"] = "作品";
translations["MSG_DASHBOARD_PLAN_USAGE_STORAGE"] = "儲存空間";

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] = "第一次玩的話\n請看教學\n喔！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] = "今天也一起\n加油吧！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] = "一起快樂地\n用拼圖學習吧！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] = "和我一起\n學習程式設計\n吧！";
translations["MSG_TOP_TUTORIAL_APP_START"] = "開始";
translations["MSG_TOP_TUTORIAL_START"] = "觀看教學";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "下次不再顯示";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "'樂學拼圖'\n介紹";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "關於「透過\n課程學習」";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "「自由創作」\n介紹";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "說明按鈕與\n我的頁面";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "關於家長\n專用選單";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "進行應用程式\n設定";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "關閉此畫面";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "下一步";
translations["MSG_TOP_TUTORIAL_START_APP"] = "開始 '樂學拼圖'";
translations["MSG_ONBOARDING_PARENT_START"] = "開始拼圖";
translations["MSG_ONBOARDING_PARENT_START_SUB"] = "新用戶需要家長註冊\n想接續資料遊玩請從這裡登入";
translations["MSG_ONBOARDING_SELF_START"] = "先試試";
translations["MSG_ONBOARDING_SELF_START_SUB"] = "無需註冊即可體驗";

// AuthSelection
translations["MSG_AUTH_SELECTION_INSTRUCTION"] = "已有帳戶請「登入」，首次使用請「註冊」。";
translations["MSG_AUTH_SIGN_IN"] = "登入";
translations["MSG_AUTH_SIGN_IN_DESC"] = "使用現有帳戶登入";
translations["MSG_AUTH_SIGN_UP"] = "註冊";
translations["MSG_AUTH_SIGN_UP_DESC"] = "建立新帳戶";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "通知";

translations["MSG_TRIAL_NOTICE_TITLE"] = "體驗期即將結束！";
translations["MSG_TRIAL_NOTICE_BODY"] = "完成監護人註冊後，可以玩得更多、做得更多。";
translations["MSG_TRIAL_NOTICE_FOR_KIDS"] = "如需繼續使用，請註冊監護人。";
translations["MSG_TRIAL_NOTICE_NOTE_FREE"] = "監護人註冊免費。";
translations["MSG_TRIAL_NOTICE_CTA"] = "前往監護人註冊";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA_HINT"] = "如需繼續使用，請前往「監護設定」。";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA"] = "監護設定";
translations["MSG_GUEST_PURCHASE_OVERLAY_HINT"] = "請前往「監護設定」";

translations["MSG_BACK_BTN"] = "返回";
translations["MSG_HOME_BTN"] = "首頁";
translations["MSG_CLOSE_BTN"] = "關閉";
translations["MSG_CANCEL_BTN"] = "取消";
translations["MSG_NEXT_BTN"] = "下一步";
translations["MSG_GENERATE_BTN"] = "生成";
translations["MSG_CONFIRM_BTN"] = "確定";
translations["MSG_SAVE_BTN"] = "保存";
translations["MSG_STOP_BTN"] = "停止";
translations["MSG_DELETE_BTN"] = "刪除";
translations["MSG_PARENTS_CANCEL_BTN"] = "取消";
translations["MSG_PARENTS_CONFIRM_BTN"] = "確定";
translations["MSG_PARENTS_DELETE_BTN"] = "刪除";
translations["MSG_ERROR_RELOAD_BTN"] = "重試";
translations["MSG_ERROR_TITLE"] = "無法正確完成處理。";
translations["MSG_ERROR_MESSAGE"] = "請再試一次。\n如果重試後仍然出現此畫面，請諮詢家長。";
// 台灣常用格式

translations["MSG_TOAST_FAILED"] = "失敗";
translations["MSG_TOAST_SEND_FAILED"] = "傳送失敗";
translations["MSG_TOAST_EDIT_SUCCESS"] = "變更成功";
translations["MSG_TOAST_DELETED_SUCCESS"] = "刪除成功";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "發佈成功";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "取消發佈成功";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "允許複製";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "禁止複製";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "已還原應用程式";
translations["MSG_TOAST_COPY"] = "已複製。";
translations["MSG_TOAST_PAST"] = "已貼上。";
translations["MSG_TOAST_UNDO"] = "已復原。";
translations["MSG_TOAST_REDO"] = "已重做。";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "已新增圖片。";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "已新增範本。";
translations["MSG_TOAST_CONTACT_SEND"] = "已傳送詢問。";
translations["MSG_SETTING_TOP_TUTORIAL"] = "應用程式啟動畫面";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "啟動時顯示";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "不顯示";
translations["MSG_SETTING_APP_LANGUAGE"] = "應用程式顯示語言";
translations["MSG_SETTING_SOUND"] = "音效";
translations["MSG_SETTING_BGM"] = "音樂";
translations["MSG_SETTING_PARENT_GATE"] = "監護設定";
translations["MSG_SETTING_GO_TO_TOP"] = "首頁";
translations["MSG_SETTING_GO_TO_CONTACT"] = "聯絡我們";
translations["MSG_SETTING_GO_TO_REVIEW"] = "評價應用程式";
translations["MSG_SETTING_GO_TO_ASSISTANT"] = "和學伴君聊天";
translations["MSG_ASSISTANT_NAME"] = "學伴君";
translations["MSG_ASSISTANT_STATUS"] = "可以聊天哦！";
translations["MSG_ASSISTANT_YOU"] = "你";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "輸入訊息...";
translations["MSG_ASSISTANT_SEND"] = "發送";
translations["MSG_ASSISTANT_STOP"] = "停止";
translations["MSG_ASSISTANT_GREETING"] = "%{name}，你好！\n我是學伴君。\n有什麼問題嗎？";
translations["MSG_ASSISTANT_USAGE_COUNT"] = "今天 %{remaining}/%{limit}次";
translations["MSG_ASSISTANT_EDUCATION_UNAVAILABLE"] = "教室方案無法與學伴君聊天";
translations["MSG_ASSISTANT_PARENT_NOT_ALLOWED"] = "家長沒有允許使用這個功能";
translations["MSG_ASSISTANT_SELECT_IMAGE"] = "選擇照片";
translations["MSG_ASSISTANT_TAB_ALBUM"] = "相簿";
translations["MSG_ASSISTANT_TAB_DRAWING"] = "繪畫";
translations["MSG_ASSISTANT_TAB_AI"] = "AI創作";
translations["MSG_ASSISTANT_STAMP_TAB"] = "貼圖";
translations["MSG_ASSISTANT_LIMIT_REACHED"] = "今天的聊天結束了！明天見！";
translations["MSG_ASSISTANT_NEW_CHAT"] = "新對話";
translations["MSG_ASSISTANT_UPGRADE_BTN"] = "增加次數";
translations["MSG_ASSISTANT_AI_ERROR"] = "現在無法回覆，請稍等一下再試一次！";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_TITLE"] = "從頭開始！";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_MESSAGE"] =
  "重新開始對話\n換個話題也沒問題\n隨時可以輕鬆開始";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_BTN"] = "開始對話";
translations["MSG_SETTING_CLOSE_BTN"] = "關閉此畫面";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "檢視課程答案";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企業合作認證";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "前往 '樂學拼圖' 網站";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "服務條款";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "隱私權政策";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "聯絡我們";
// 使用計數範例
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "恢復遊玩";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "恢復此使用者的遊玩。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "暫停遊玩";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] = "暫停此使用者的遊玩。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "無法啟用";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "最多只能有 4 位有效使用者。\n若要啟用此使用者，請先停用（或刪除）另一位不需要的使用者。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "無法變更";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "至少需要一位使用者。\n無法再減少使用者數量。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "無法變更";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "無法暫停目前登入的使用者。\n請先切換到其他使用者，然後再暫停此使用者。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "登出";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "登出帳戶後，您將無法使用目前的使用者遊玩。\n使用者資訊已儲存在帳戶中，如果您想再次使用相同的使用者遊玩，請使用此帳戶重新登入。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】請注意";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "從 '樂學拼圖' 刪除您的帳戶將刪除以下所有資料：\n・註冊的個人資料和帳戶資訊。\n・所有已註冊的使用者資訊。\n・使用者在「自由創作」中建立的應用程式。\n・使用者在「透過課程學習」中完成的所有成績和成就。\n・使用者進行的「對話紀錄」等。\n* 【重要】刪除已登入的帳戶將刪除與此帳戶相關的所有資料，請務必小心。\n* 【重要】此操作在任何情況下都無法復原。刪除帳戶時請務必小心。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] = "請告訴我們刪除帳戶的原因。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "您確定要刪除帳戶嗎？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "刪除帳戶將移除所有資料，包括帳戶和使用者。\n帳戶刪除後無法復原。請小心操作。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] = "無法連結";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "社群帳戶已連結到另一個帳戶。";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "註冊日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "最後登入日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "刪除帳戶";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] = "%{limit}字元以內。";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "選擇課程";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "選擇關卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "選擇等級";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "關卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "等級";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "驗證碼";

translations["MSG_CONTACT_TITLE"] = "聯絡我們";
translations["MSG_CONTACT_TYPE_TITLE"] = "選擇聯絡類型";
translations["MSG_CONTACT_DETAIL_TITLE"] = "請詳細描述您的問題或需求。";
translations["MSG_CONTACT_DETAIL_LOCKED"] = "在上方選擇類型後，就可以在這裡填寫";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "不知道\n如何使用";
translations["MSG_CONTACT_TYPE_BUG"] = "無法\n正常運作";
translations["MSG_CONTACT_TYPE_REQUEST"] = "希望新增的\n功能";
translations["MSG_CONTACT_TYPE_OTHER"] = "其他\n問題";
translations["MSG_CONTACT_SEND_BTN"] = "送出";
translations["MSG_SETTING_SHAKE_BUG_REPORT"] = "搖動告知";
translations["MSG_SHAKE_BUG_REPORT_TITLE"] = "有無法使用的地方嗎？";
translations["MSG_SHAKE_BUG_REPORT_DESCRIPTION"] =
  "請透過詢問告訴我們。\n也可以一併送出搖動時的畫面。";
translations["MSG_SHAKE_BUG_REPORT_CONTACT_BTN"] = "聯絡我們";
translations["MSG_SHAKE_BUG_REPORT_CAPTURE_BTN"] = "附上畫面聯絡我們";
translations["MSG_SHAKE_BUG_REPORT_TOGGLE_LABEL"] = "搖動告知";
translations["MSG_SHAKE_BUG_REPORT_TOGGLE_DESCRIPTION"] = "關閉後，搖動將不再顯示此畫面。";
translations["MSG_CONTACT_CAPTURE_LABEL"] = "送出的畫面";
translations["MSG_CONTACT_CAPTURE_DESCRIPTION"] = "可以一併送出\n開啟前的畫面";
translations["MSG_CHAT_CAPTURE_SCREEN_BTN"] = "擷取畫面";
translations["MSG_CHAT_HINT_CAPTURE"] = "擷取開啟前的畫面並附上";
translations["MSG_CHAT_HINT_UPLOAD"] = "附上照片或圖片檔案";
translations["MSG_CHAT_HINT_ASSET"] = "從「相冊」「素描簿」「AI工作室」附上圖片";
translations["MSG_CHAT_HINT_STAMP"] = "傳送貼圖";
translations["MSG_CHAT_ATTACHED_IMAGE_LABEL"] = "要送出的圖片";
translations["MSG_CONTACT_CAPTURE_REMOVE_BTN"] = "移除";

translations["MSG_PARENT_GATE_WARNING"] = "這個頁面\n要請大人\n確認一下\n再進入喔";
translations["MSG_PARENT_GATE_TITLE"] = "給家長的提示";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "此後的頁面將包含保護者專用的設定和帳戶信息。\n要顯示此頁面，請按照以下圖示操作。";
translations["MSG_PARENT_GATE_CLOSE_BTN"] = translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "確定";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] = "請按照以下順序點擊圖示：";
translations["MSG_PARENT_GATE_LONGPRESS_INSTRUCTION"] = "長按數字 「%{number}」。";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "矩形";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "星形";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "圓形";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "三角形";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_PARENT_REGISTRATION_MESSAGE_COURSE"] =
  "「體驗方案」只能遊玩演算法冒險的第1關和第2關。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_PROJECT_LIMIT"] =
  "「體驗方案」最多可以建立%{limit}個應用。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_CHILD_USER_LIMIT"] =
  "「體驗方案」最多可以新增%{limit}名玩家。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_CHAT_LIMIT"] =
  "「體驗方案」每天最多可傳送%{limit}次。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_IMAGE_LIMIT"] =
  "「體驗方案」每天最多可製作%{limit}次。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_ASSET_LIMIT"] =
  "「體驗方案」最多可儲存 100 MB 的素材。";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] = "這個卡帶還不能玩。\n再等一下吧！";
translations["MSG_COURSE_START_BTN"] = "開始";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "地圖";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "這裡已經完成了！";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "在這個等級中學習";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "開始";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "下一關";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "上一關";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "試試看";
translations["MSG_COURSE_GAME_HINT_BTN"] = "提示";
translations["MSG_COURSE_GAME_CLEAR"] = "完成";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "獲得的物品";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "這/%{total}個";
translations["MSG_COURSE_GAME_START_BTN"] = "開始！";
translations["MSG_COURSE_GAME_RESET_BTN"] = "重來";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] = "恭喜！你完成了這個等級！";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "再試一次";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "進入下一個等級";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "進入下一個關卡";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "失敗！";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "再試一次吧！\n\n當你覺得難以理解時，\n可以參考提示。";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "再試一次";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "恭喜！你完成了這個關卡！";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "恭喜！\n現在 你已經完成了\n所有 關卡！\n新的關卡將會在\n這裡出現，請耐心等待！";
translations["MSG_COURSE_PROGRAM_RUN"] = "開始";
translations["MSG_COURSE_ALGORITHM"] = "學習演算法！";
translations["MSG_COURSE_PROGRAM"] = "程式設計入門";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "演算法進階";
translations["MSG_COURSE_SOKOBAN"] = "推箱子謎題";
translations["MSG_COURSE_SOKOBAN_DESCRIPTION"] = "推動箱子，送到目的地！";
translations["MSG_COURSE_SOKOBAN_LEVEL"] = "關卡";
translations["MSG_COURSE_PIECE_BUILDER"] = "拼圖建造";
translations["MSG_BUILDER_TAB_MY_MAPS"] = "我的拼圖";
translations["MSG_BUILDER_TAB_PUBLIC_MAPS"] = "大家的拼圖";
translations["MSG_BUILDER_TAB_TRASH"] = "垃圾桶";
translations["MSG_BUILDER_ENTRY_MINE_DESC"] =
  "可以製作只屬於自己的拼圖。做好的拼圖還可以修改，也可以公開給大家。";
translations["MSG_BUILDER_ENTRY_PUBLIC_DESC"] =
  "可以玩其他人製作並公開的拼圖。喜歡的拼圖可以按「讚」。";
translations["MSG_BUILDER_ENTRY_OPEN_BTN"] = "打開";
translations["MSG_BUILDER_LIST_TITLE"] = "拼圖建造";
translations["MSG_BUILDER_LAYOUT_GRID_1"] = "1欄";
translations["MSG_BUILDER_LAYOUT_GRID_2"] = "2欄";
translations["MSG_BUILDER_LAYOUT_LIST"] = "清單";
translations["MSG_BUILDER_LAYOUT_SWITCH"] = "切換版面";
translations["MSG_BUILDER_SECTION_FILTER"] = "篩選";
translations["MSG_BUILDER_CLEAR_BTN"] = "清除";
translations["MSG_BUILDER_SECTION_SORT"] = "排序";
translations["MSG_BUILDER_SECTION_LAYOUT"] = "顯示";
translations["MSG_BUILDER_PUBLIC_COMING_SOON"] = "即將開放！";
translations["MSG_BUILDER_NEW_PIECE_NAME"] = "新拼圖";
translations["MSG_BUILDER_NEW_MAP_BTN"] = "新拼圖";
translations["MSG_BUILDER_SCROLL_TO_BOTTOM_BTN"] = "捲動到底部";
translations["MSG_BUILDER_NEW_MAP_TITLE"] = "建立新拼圖";
translations["MSG_BUILDER_MAP_DETAIL_BTN"] = "詳情";
translations["MSG_BUILDER_MAP_EDIT_BTN"] = "編輯";
translations["MSG_BUILDER_MAP_RUN_BTN"] = "執行";
translations["MSG_BUILDER_MAP_COUNT"] = "%{count} 個拼圖";
translations["MSG_BUILDER_FILTER_ALL"] = "全部";
translations["MSG_BUILDER_FILTER_FAVORITE"] = "收藏";
translations["MSG_BUILDER_FILTER_DRAFT"] = "草稿";
translations["MSG_BUILDER_FILTER_EDITING"] = "編輯中";
translations["MSG_BUILDER_FILTER_AXIS_COMPLETED"] = "完成狀態";
translations["MSG_BUILDER_FILTER_AXIS_PUBLISHED"] = "公開狀態";
translations["MSG_BUILDER_FILTER_AXIS_OTHER"] = "其他";
translations["MSG_BUILDER_SORT_DESC"] = "最新";
translations["MSG_BUILDER_SORT_ASC"] = "最舊";
translations["MSG_BUILDER_SORT_POPULAR"] = "人氣";
translations["MSG_BUILDER_SORT_MANY"] = "數量多";
translations["MSG_BUILDER_SORT_FEW"] = "數量少";
translations["MSG_BUILDER_SORT_AXIS_UPDATED"] = "日期";
translations["MSG_BUILDER_SORT_AXIS_DELETED"] = "刪除日";
translations["MSG_BUILDER_SORT_AXIS_LIKED"] = "讚";
translations["MSG_BUILDER_SORT_AXIS_PLAYED"] = "遊玩";
translations["MSG_BUILDER_SORT_AXIS_VIEWED"] = "瀏覽";
translations["MSG_BUILDER_SORT_AXIS_REACTION"] = "反應";
translations["MSG_BUILDER_SORT_ORDER"] = "順序";
translations["MSG_BUILDER_PUBLIC_COUNT"] = "%{count} 個拼圖";
translations["MSG_BUILDER_PUBLIC_FILTER_OFFICIAL"] = "官方";
translations["MSG_BUILDER_PUBLIC_FILTER_TEMPLATE_AXIS"] = "類型";
translations["MSG_BUILDER_PUBLIC_FILTER_UNOFFICIAL"] = "非官方";
translations["MSG_BUILDER_PUBLIC_FILTER_COPYABLE"] = "可複製";
translations["MSG_BUILDER_PUBLIC_FILTER_REMIX"] = "二次創作";
translations["MSG_BUILDER_PUBLIC_FILTER_POPULAR"] = "人氣";
translations["MSG_BUILDER_PUBLIC_FILTER_COMMENTABLE"] = "可評論";
translations["MSG_BUILDER_PUBLIC_FILTER_COPIED"] = "複製";
translations["MSG_BUILDER_TRASH_COUNT"] = "垃圾桶 %{count} 個";
translations["MSG_BUILDER_TRASH_SORT"] = "依刪除時間";
translations["MSG_BUILDER_CARD_STATUS_DRAFT"] = "草稿";
translations["MSG_BUILDER_CARD_STATUS_EDITING"] = "編輯中";
translations["MSG_BUILDER_CARD_STATUS_UNPUBLISHED"] = "未公開";
translations["MSG_BUILDER_CARD_STATUS_PUBLISHED"] = "公開中";
translations["MSG_BUILDER_CARD_STATUS_COMPLETED"] = "已完成";
translations["MSG_BUILDER_CARD_STATUS_INCOMPLETE"] = "製作中";
translations["MSG_BUILDER_CARD_STATUS_REMOVED"] = "已刪除";
translations["MSG_BUILDER_CARD_STATUS_BLOCKED"] = "已被封鎖";
translations["MSG_BUILDER_CARD_STATUS_OFFICIAL"] = "官方";
translations["MSG_BUILDER_CARD_STATUS_ORIGINAL"] = "原創";
translations["MSG_BUILDER_CARD_STATUS_REMIX"] = "二次創作";
translations["MSG_BUILDER_CARD_BADGE_REMIX"] = "混編";
translations["MSG_BUILDER_CARD_REMIX_FROM"] = "原作: %{name}";
translations["MSG_BUILDER_BTN_PLAY"] = "玩";
translations["MSG_BUILDER_BTN_CONTINUE"] = "繼續";
translations["MSG_BUILDER_BTN_PUBLISHED_NOW"] = "玩已公開版";
translations["MSG_BUILDER_BTN_RESUME"] = "繼續編輯";
translations["MSG_BUILDER_BTN_RESTORE"] = "復原";
translations["MSG_BUILDER_TOOL_UNDO"] = "復原";
translations["MSG_BUILDER_TOOL_REDO"] = "重做";
translations["MSG_BUILDER_TOOL_TAP"] = "點選";
translations["MSG_BUILDER_TOOL_ERASER"] = "橡皮擦";
translations["MSG_BUILDER_TOOL_ZOOM"] = "縮放";
translations["MSG_BUILDER_TOOL_RESET"] = "重置";
translations["MSG_BUILDER_TOOL_ZOOM_OUT"] = "縮小";
translations["MSG_BUILDER_TOOL_ZOOM_IN"] = "放大";
translations["MSG_BUILDER_BTN_PUBLISH"] = "公開";
translations["MSG_BUILDER_BTN_UNPUBLISH"] = "設為私密";
translations["MSG_BUILDER_TOGGLE_PUBLISH_TOAST"] = "已公開";
translations["MSG_BUILDER_TOGGLE_UNPUBLISH_TOAST"] = "已設為私密";
translations["MSG_BUILDER_BTN_DELETE_FOREVER"] = "刪除";
translations["MSG_BUILDER_BTN_COPY"] = "複製";
translations["MSG_BUILDER_MENU_HINT"] = "寫提示";
translations["MSG_BUILDER_MENU_COPY"] = "複製並建立";
translations["MSG_BUILDER_MENU_TO_TRASH"] = "移到垃圾桶";
translations["MSG_BUILDER_MENU_LIKE"] = "讚";
translations["MSG_BUILDER_MENU_REACTION"] = "反應";
translations["MSG_BUILDER_OPEN_PIECE_BTN"] = "查看拼圖";
translations["MSG_BUILDER_MENU_REPORT"] = "檢舉";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_TITLE"] = "移到垃圾桶？";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_MSG"] = "將「%{name}」移到垃圾桶。之後可以復原。";
translations["MSG_BUILDER_TO_TRASH_TOAST"] = "已移到垃圾桶";
translations["MSG_BUILDER_TRASH_RESTORE_TOAST"] = "已復原";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_TITLE"] = "永久刪除？";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_MSG"] = "永久刪除「%{name}」。無法復原。";
translations["MSG_BUILDER_TRASH_DELETE_TOAST"] = "已刪除";
translations["MSG_BUILDER_LIKE_TOAST"] = "已按讚！";
translations["MSG_BUILDER_COPY_TOAST"] = "已複製！";
translations["MSG_BUILDER_RESTORE_CONFIRM_TITLE"] = "要還原嗎？";
translations["MSG_BUILDER_REPORT_THANKS"] = "謝謝你告訴我們！";
translations["MSG_BUILDER_REPORT_PIECE_CONFIRM"] = "將告知營運團隊。\n對方不會知道是誰回報的。";
translations["MSG_BUILDER_REPORT_REASON_TITLE"] = "為什麼要回報？";
translations["MSG_BUILDER_REPORT_REASON_INAPPROPRIATE"] = "不好的詞語";
translations["MSG_BUILDER_REPORT_REASON_DISLIKE"] = "不舒服";
translations["MSG_BUILDER_REPORT_REASON_SPAM"] = "重複很多";
translations["MSG_BUILDER_REPORT_REASON_COPYRIGHT"] = "別人的作品";
translations["MSG_BUILDER_REPORT_REASON_OTHER"] = "其他";
translations["MSG_BUILDER_REPORT_DETAIL_LABEL"] = "請詳細告訴我們";
translations["MSG_BUILDER_COPY_NOT_ALLOWED"] = "這個拼圖不能複製";
translations["MSG_BUILDER_REPORT_NEED_ACCOUNT"] = "只有註冊使用者才能檢舉。";
translations["MSG_BUILDER_DETAIL_TAB_RANKING"] = "排行榜";
translations["MSG_BUILDER_DETAIL_AUTHOR_BY"] = "%{name} 製作";
translations["MSG_BUILDER_DETAIL_PUBLISHED_AT"] = "公開日";
translations["MSG_BUILDER_DETAIL_UPDATED_AT"] = "更新日";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES"] = "最少步數";
translations["MSG_BUILDER_DETAIL_RANKING_TIME"] = "最快時間";
translations["MSG_BUILDER_DETAIL_RANKING_WORLD"] = "世界紀錄";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES_UNIT"] = "%{n} 步";
translations["MSG_BUILDER_DETAIL_RANKING_EMPTY"] = "還沒有人通關";
translations["MSG_BUILDER_DETAIL_HINT_EMPTY"] = "沒有提示";
translations["MSG_BUILDER_DETAIL_RANKING_YOU"] = "你";
translations["MSG_BUILDER_DETAIL_HINT_TITLE"] = "寫提示";
translations["MSG_BUILDER_DETAIL_HINT_DESC"] = "留空會自動生成";
translations["MSG_BUILDER_DETAIL_HINT_LV1"] = "① 簡單";
translations["MSG_BUILDER_DETAIL_HINT_LV2"] = "② 普通";
translations["MSG_BUILDER_DETAIL_HINT_LV3"] = "③ 答案";
translations["MSG_BUILDER_DETAIL_HINT_PLACEHOLDER"] = "寫下提示";
translations["MSG_BUILDER_DETAIL_HINT_SECTION"] = "提示";
translations["MSG_BUILDER_DETAIL_CHANGE_COVER"] = "更換封面";
translations["MSG_BUILDER_DETAIL_CHANGE_BACKGROUND"] = "更換背景";
translations["MSG_BUILDER_DETAIL_EDIT_BTN"] = "修改";
translations["MSG_BUILDER_CARD_DETAIL_BTN"] = "更多";
translations["MSG_BUILDER_DETAIL_TAB_COMMAND"] = "指令";
translations["MSG_BUILDER_DETAIL_TAB_COMMENT"] = "評論";
translations["MSG_BUILDER_DETAIL_REACTION_HINT"] = "點一下告訴對方感受";
translations["MSG_BUILDER_DETAIL_REACTION_TITLE"] = "大家的感受";
translations["MSG_BUILDER_DETAIL_COMMAND_DESC"] = "這塊拼圖可以使用的指令";
translations["MSG_BUILDER_DETAIL_COMMENT_INPUT_PLACEHOLDER"] = "寫下你的評論";
translations["MSG_BUILDER_DETAIL_COMMENT_POST"] = "發布";
translations["MSG_BUILDER_DETAIL_COMMENT_SHOW_REPLIES"] = "查看回覆 (%{n})";
translations["MSG_BUILDER_DETAIL_COMMENT_HIDE_REPLIES"] = "收起回覆";
translations["MSG_BUILDER_DETAIL_COMMENT_DELETE"] = "刪除";
translations["MSG_BUILDER_DETAIL_COMMENT_REPORT"] = "檢舉";
translations["MSG_BUILDER_DETAIL_COMMENT_REPLY"] = "回覆";
translations["MSG_BUILDER_DETAIL_COMMENT_REPORT_CONFIRM"] =
  "將告知營運團隊。\n對方不會知道是誰回報的。";
translations["MSG_BUILDER_DETAIL_COMMENT_DELETE_CONFIRM"] = "要刪除這則留言嗎？";
translations["MSG_BUILDER_DETAIL_COMMENT_GUEST_HINT"] = "註冊後即可評論";
translations["MSG_BUILDER_DETAIL_COMMENT_EMPTY"] = "還沒有留言";
translations["MSG_BUILDER_DETAIL_TIME_MIN_AGO"] = "%{n} 分鐘前";
translations["MSG_BUILDER_DETAIL_TIME_HOUR_AGO"] = "%{n} 小時前";
translations["MSG_BUILDER_DETAIL_TIME_DAY_AGO"] = "%{n} 天前";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_TITLE"] = "遊戲玩法";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_DESC"] = "把所有箱子推到目標上！";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_TITLE"] = "操作方法";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_DESC"] = "用右下方的按鈕來移動角色";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_TITLE"] = "攝影機操作";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_DESC"] = "拖動左下方的圓圈可以旋轉攝影機";
translations["MSG_SOKOBAN_TUTORIAL_BTN_FORWARD"] = "前進";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_LEFT"] = "左轉";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_RIGHT"] = "右轉";
translations["MSG_SOKOBAN_TUTORIAL_BTN_JUMP"] = "跳躍";
translations["MSG_SOKOBAN_TUTORIAL_NEXT_BTN"] = "下一步";
translations["MSG_SOKOBAN_TUTORIAL_START_BTN"] = "開始！";
translations["MSG_SOKOBAN_TUTORIAL_TITLE"] = "新手教學";
translations["MSG_SOKOBAN_TUTORIAL_TAP_TO_CONTINUE"] = "點擊繼續";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_HINT"] = "目標在這裡！";
translations["MSG_COURSE_GROUP_WORK"] = "小組合作";
translations["MSG_COURSE_COORDINATE_X"] = "橫向位置（X座標）";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "下一關";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "稍後再看";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "繼續指南";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "試試看";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "結束指南";
translations["MSG_CREATOR_CREATE_APP"] = "創建應用程式";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "製作應用程式";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "請為您的應用程式命名。";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "應用程式";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "詳細";
translations["MSG_CREATOR_RUN_APP_BTN"] = "運行";
translations["MSG_CREATOR_APP_MY_APPS"] = "我的應用程式";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "大家的應用程式";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "沒有符合條件的應用程式。\n請更改條件後再試一次。";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "垃圾桶";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "選擇您想移回\n「我的應用程式」的應用程式。\n（最多保留5個\n最近刪除的應用程式）";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "應用程式設定";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "應用程式名稱";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "標籤";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] = "發佈至「共享應用程式」？";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "不公開";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "公開";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] = "自我介紹使用者可以複製";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] = "禁止\n複製";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] = "允許\n複製";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] = "更換封面";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "最初製作的人";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "重新製作的人";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "請輸入名稱";
translations["MSG_CREATOR_APP_SELECT_PLACEHOLDER"] = "select app";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "應用程式描述";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "沒有描述";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] = "請輸入應用程式描述";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "應用程式\n代碼";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "大家的\n應用程式";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "已發佈";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] = "未發佈";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "自我介紹\n使用者";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "可以複製";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] = "無法複製";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "刪除\n日期";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "製作";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "完全刪除";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "恢復原狀";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "確定要刪除應用程式嗎？";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  "確定要刪除「%{name}」嗎？\n刪除後將無法恢復，請小心操作。\n應用程式將無法使用。";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "確定要刪除圖片嗎？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "確定要刪除「%{name}」嗎？\n刪除後將無法恢復，請小心操作。";
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "精選";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}月的";
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] = "看看有什麼吸引您的應用程式！";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "發佈至「共享應用程式」？";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "無法發佈應用程式";
translations["MSG_CREATOR_APP_BLOCKED"] = "已被封鎖\n無法公開";
translations["MSG_CREATOR_APP_CARD_BLOCKED"] = "已封鎖";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "發佈應用程式需要保護者同意。\n請從保護者選單中啟用。";
// 運営がかけた機能の制限（管理画面から。保護者の許可とは別）
translations["MSG_USER_RESTRICTION_PROJECT_PUBLISH_MESSAGE"] =
  "營運%{until}停止了應用程式的發佈。\n詳情請查看「聯絡我們」。";
translations["MSG_USER_RESTRICTION_PIECE_PUBLISH_TITLE"] = "無法發佈拼圖";
translations["MSG_USER_RESTRICTION_PIECE_PUBLISH_MESSAGE"] =
  "營運%{until}停止了拼圖的發佈。\n詳情請查看「聯絡我們」。";
translations["MSG_USER_RESTRICTION_UNTIL"] = "到%{date}為止";
translations["MSG_USER_RESTRICTION_UNTIL_NONE"] = "暫時";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] = "停止發佈至「共享應用程式」？";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "將「%{name}」發佈至「共享應用程式」。\n自我介紹使用者將可以使用此應用程式。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "將「%{name}」設為不公開。\n不發佈後，自我介紹使用者將無法使用此應用程式。";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "允許複製並發佈";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] = "禁止複製並發佈";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] = "※應用程式可以在稍後停止發佈。";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "發佈";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "不公開";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] = "此應用程式的複製設定";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] = "此應用程式的複製設定";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] = "自我介紹使用者可以複製「%{name}」。";
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] =
  "自我介紹使用者無法複製「%{name}」，禁止複製。";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] = "此圖片無法使用";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "只能添加最新製作的%{limit}張圖片。\n自我介紹圖片也可以使用，請告訴我們。";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] = "無法刪除發佈中的應用程式";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "大家的應用程式中正在發佈的應用程式無法刪除。\n如果您想刪除應用程式，請先停止發佈。\n";
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "尋找";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "用詞搜索";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "排序";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "最受歡迎";
translations["MSG_CREATOR_APP_SORT_DATE"] = "時間";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "篩選";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "官方";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "收藏";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "無法製作";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] = "確定要完全刪除嗎？";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  "確定要刪除「%{name}」嗎？\n完全刪除後將無法恢復。";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] = "還原至「我的應用程式」？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] =
  "確定要將「%{name}」還原至「我的應用程式」嗎？";
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "頁面";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "選擇中";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "刪除";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "複製";
translations["MSG_CREATOR_MENU_CASSETTE_ACTION"] = "卡帶操作";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "運行\n應用程式";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "應用程式\n設定";
// じゆうにつくる: できた！・こうかいを こうしん・へんこうの きろく（ドラフトとバージョン）
translations["MSG_CREATOR_MENU_PUBLISH_UPDATE_BTN"] = "更新\n公開";
translations["MSG_CREATOR_MENU_HISTORY_BTN"] = "查看\n紀錄";
translations["MSG_CREATOR_HISTORY_TITLE"] = "查看紀錄";
translations["MSG_CREATOR_HISTORY_EMPTY"] = "還沒有紀錄";
translations["MSG_CREATOR_HISTORY_REASON_COMPLETE"] = "完成！";
translations["MSG_CREATOR_HISTORY_REASON_PUBLISH_UPDATE"] = "更新了公開";
translations["MSG_CREATOR_HISTORY_REASON_PUBLISH"] = "公開了";
translations["MSG_CREATOR_HISTORY_REASON_CLOSE"] = "關閉了應用程式";
translations["MSG_CREATOR_HISTORY_REASON_OPEN"] = "打開了應用程式";
translations["MSG_CREATOR_HISTORY_REASON_BEFORE_RESTORE"] = "恢復之前";
translations["MSG_CREATOR_HISTORY_REASON_MIGRATE"] = "最初的公開版本";
translations["MSG_CREATOR_HISTORY_REASON_AUTO"] = "中途的紀錄";
translations["MSG_CREATOR_HISTORY_REASON_RESTORE"] = "已還原";
translations["MSG_CREATOR_HISTORY_SAVE_BTN"] = "命名並儲存";
translations["MSG_CREATOR_HISTORY_SAVE_DEFAULT_NAME"] = "存檔點_%{time}";
translations["MSG_CREATOR_HISTORY_SAVE_NAME_DESCRIPTION"] = "請為這筆紀錄取個名字。";
translations["MSG_CREATOR_HISTORY_REASON_SAVE"] = "已儲存";
translations["MSG_CREATOR_TOAST_SAVED"] = "已儲存";
translations["MSG_CREATOR_HISTORY_NOW"] = "現在";
translations["MSG_CREATOR_HISTORY_EDIT_UNDO_OF"] = "復原了：%{action}";
translations["MSG_CREATOR_HISTORY_EDIT_REDO_OF"] = "重做了：%{action}";
translations["MSG_CREATOR_HISTORY_EDIT_RESTORE"] = "從紀錄還原了";
translations["MSG_CREATOR_HISTORY_RESTORE"] = "恢復";
translations["MSG_CREATOR_HISTORY_RESTORE_CONFIRM_TITLE"] = "要恢復到這個時候嗎？";
translations["MSG_CREATOR_HISTORY_RESTORE_CONFIRM_MESSAGE"] =
  "恢復到「%{time}」的時候。\n現在的內容也會留在紀錄裡，之後還能恢復。";
translations["MSG_CREATOR_HISTORY_RESTORE_CONFIRM_MESSAGE_PUBLISHED"] =
  "恢復到「%{time}」的時候。\n現在的內容也會留在紀錄裡，之後還能恢復。\n公開中的應用程式在按下「更新公開」之前不會改變。";
translations["MSG_CREATOR_HISTORY_LIMIT_NOTE"] = "可以查看最新的%{limit}個（共%{total}個）";
translations["MSG_CREATOR_HISTORY_EDIT_ADD"] = "新增了%{target}";
translations["MSG_CREATOR_HISTORY_EDIT_REMOVE"] = "刪除了%{target}";
translations["MSG_CREATOR_HISTORY_EDIT_CHANGE"] = "修改了%{target}";
translations["MSG_CREATOR_HISTORY_EDIT_CHANGE_BLOCKLY"] = "修改了%{target}的積木";
translations["MSG_CREATOR_HISTORY_EDIT_PASTE"] = "貼上了";
translations["MSG_CREATOR_HISTORY_EDIT_UNDO"] = "復原了一步";
translations["MSG_CREATOR_HISTORY_EDIT_REDO"] = "重做了";
translations["MSG_CREATOR_HISTORY_TARGET_COMPONENTS"] = "元件";
translations["MSG_CREATOR_PUBLISH_UPDATE_CONFIRM_TITLE"] = "要更新公開中的應用程式嗎？";
translations["MSG_CREATOR_PUBLISH_UPDATE_CONFIRM_MESSAGE"] = "大家看到的應用程式會變成現在的內容。";
translations["MSG_CREATOR_TOAST_PUBLISH_UPDATED"] = "已更新公開中的應用程式";
translations["MSG_CREATOR_TOAST_RESTORED"] = "已恢復到「%{time}」的時候";
translations["MSG_CREATOR_TOAST_SAVE_FAILED"] = "無法儲存。請檢查網路連線。";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "發佈\n應用程式";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "應用程式\n不公開";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "模板\n公開";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] = "模板\n不公開";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "關閉\n此畫面";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "部件";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "工作";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "形狀";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "印章";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "道具箱";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "操作部件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "形狀部件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "印章部件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "角色";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "活動・遊戲";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "生物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "事件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "互聯網";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "經濟・金錢";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "生活雜貨";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "自然・植物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "人物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "建築";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "食物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] = "家電・通信";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "微笑";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "交通工具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "文具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "自我介紹";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "繪圖";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "筆";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "橡皮擦";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "粗細";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "細";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "普通";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "粗";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "顏色";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "重置";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "完成";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "添加";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name}的部件一覽";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "相冊";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "素描簿";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "設計";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "基本";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "位置";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "尺寸";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "外觀";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "顏色";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "程序";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}的程序";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "名稱";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "請輸入名稱";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "首頁";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "從此頁面開始";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "字體種類";
translations["MSG_CREATOR_TEXT_WEIGHT_BOLD"] = "粗體";
translations["MSG_CREATOR_TEXT_WEIGHT_REGULAR"] = "一般";
translations["MSG_CREATOR_TEXT_WEIGHT_LIGHT"] = "細體";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "顯示的內容";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "重疊";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "最上面";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "最下面";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "橫向和縱向位置";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "橫向位置";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "縱向位置";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "橫";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "縱";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "寬度";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "高度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "邊框";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "陰影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "文本";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "文本的陰影";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "可見度";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "角度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "邊角圓角";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "圖片的資訊";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "名稱";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "大小";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "文件大小";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "選擇圖片";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "填充顏色";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "邊框";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "陰影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "文本";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "文本的陰影";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "積木";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "事件";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "動畫";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "控制";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "邏輯";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "運算";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "變數";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "函數";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] = "%{placeholder}的值";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "頁面";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "按鈕";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "標籤";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "表單";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "複選框";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "開關";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "圖片";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "圓";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "三角形";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "方形";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "星";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "線";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "印章";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "繪圖";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] = translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "複選\n複選框";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "圖片\n複選框";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] = translations["MSG_CREATOR_COMPONENT_NAME_RECT"];
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] = translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] = translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "變數";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "請輸入數字。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "%{limit}字元以內。";
translations["MSG_ASSET_ALBUM_TITLE"] = "相冊內容";
translations["MSG_ASSET_DRAWING_TITLE"] = "素描簿內容";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "添加圖片";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "在「自由創作」中添加的圖片和照片將會添加到這裡。";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "在「自由創作」的「繪圖」選單中繪製的圖畫將會添加到這裡。";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "新增到\n應用程式";
translations["MSG_CREATOR_MENU_MATERIAL_TAB_ASSET_SELECT"] = "添加到\n聊天";
translations["MSG_ASSET_DELETE_BTN"] = "刪除\n圖片";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "還沒有 圖片資料。";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "還沒有 繪圖的 資料。";
translations["MSG_ASSET_STORAGE_OVER_LIMIT"] = "儲存空間已滿";
translations["MSG_REACTION_TAG_TITLE"] = "情緒印章";
translations["MSG_REACTION_USERS"] = "大家的\n情緒";
translations["MSG_REACTION_DIFFICULT"] = "有點難度！";
translations["MSG_REACTION_EASY"] = "簡單";
translations["MSG_REACTION_COOL"] = "很棒！";
translations["MSG_REACTION_FUN"] = "有趣";
translations["MSG_REACTION_AMAZING"] = "很厲害！";
translations["MSG_REACTION_BAD"] = "嗯......";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "人氣";

// User Plan
translations["MSG_CURRENT_PLAN"] = "目前方案";
translations["MSG_PLAN_TRIAL"] = "試用";
translations["MSG_PLAN_SAKIDORI"] = "搶先體驗";
translations["MSG_PLAN_FREE"] = "免費";
translations["MSG_PLAN_EDUCATION"] = "教室";
translations["MSG_PLAN_STANDARD"] = "基本";
translations["MSG_PLAN_PREMIUM"] = "高級";
translations["MSG_PLAN_BUILDER"] = "創作者";
translations["MSG_PLAN_UNKNOWN"] = "未知";
translations["MSG_PLAN_FREE_FULL"] = "免費方案";
translations["MSG_PLAN_STANDARD_FULL"] = "基本方案";
translations["MSG_PLAN_PREMIUM_FULL"] = "高級方案";
// Plan names for parent pages
translations["MSG_PLAN_TRIAL_PARENT"] = "試用";
translations["MSG_PLAN_FREE_PARENT"] = "免費";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PLAN_PREMIUM_PARENT"] = "高級";
translations["MSG_PLAN_BUILDER_PARENT"] = "創作者";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_UNKNOWN_PARENT"] = "未知";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "免費方案";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本方案";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "高級方案";

// Subscription - Common
translations["MSG_BACK_BTN"] = "返回";
// Subscription - Purchase Page
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月訂閱";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年訂閱";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "節省2個月費用！";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "購買";
translations["MSG_SUBSCRIPTION_UPGRADE_BTN"] = "升級";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "購買成功！";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "購買失敗，請重試。";
// Subscription - Status Page
translations["MSG_SUBSCRIPTION_REACTIVATE_SUCCESS"] = "訂閱已恢復";
translations["MSG_SUBSCRIPTION_REACTIVATE_ERROR"] = "恢復訂閱失敗";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "無法開啟入口";

// Subscription - Cancel Page
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_TITLE"] = "確定要取消嗎？";
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_MESSAGE"] =
  "您的訂閱將在下次計費日期取消，您將返回免費計劃。\n您的數據將被保留。";
translations["MSG_SUBSCRIPTION_CANCEL_SUCCESS"] = "已受理取消訂閱";
translations["MSG_SUBSCRIPTION_CANCEL_ERROR"] = "取消訂閱失敗";
// 退款（冷靜期）
// Stripe Elements付款模態框
// 家長頁面 - 標籤頁
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "家長帳號";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "玩家管理";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "訂閱管理";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "通知";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "訊息";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "其他";

// 家長頁面 - 訊息標籤頁
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "輸入訊息...";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "沒有聊天室";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "暫無訊息";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "載入更多";
translations["MSG_LOADING"] = "載入中...";

// 家長頁面 - 方案名稱
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "購買方式";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] = "您正在使用企業合約。詳情請聯繫管理員。";

// 家長頁面 - 帳號標籤頁
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "帳號資訊";
translations["MSG_PARENT_PAGE_NICKNAME"] = "暱稱";
translations["MSG_PARENT_PAGE_ICON"] = "頭像";
translations["MSG_PARENT_PAGE_EMAIL"] = "電子郵件";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "郵件驗證";
translations["MSG_PARENT_PAGE_VERIFIED"] = "已驗證";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "註冊日期";
translations["MSG_PARENT_PAGE_CHANGE"] = "變更";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "帳號綁定";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Google帳號";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_LINK"] = "綁定";
translations["MSG_PARENT_PAGE_UNLINK"] = "解除綁定";

// 家長頁面 - 個人資料部分
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "個人資料";
translations["MSG_PARENT_PAGE_PROFILE_EDIT_TITLE"] = "編輯個人資料";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本資料";
translations["MSG_PARENT_PAGE_PROFILE_REGION_PLACEHOLDER"] = "例如：台北市";
translations["MSG_PARENT_PAGE_PROFILE_CITY_PLACEHOLDER"] = "例如：信義區";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自我介紹備註";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本資料";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "個性";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "頭像";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未設定";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "編輯喜歡的顏色";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "編輯自我介紹";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "個人資料更新成功";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "個人資料更新失敗";

// 家長頁面 - 頭像編輯彈窗
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT"] = "當前";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED"] = "用這個？";
translations["MSG_ICON_CHANGE_CONFIRM_BTN"] = "確定";
translations["MSG_ICON_CHANGE_AI_CANCEL"] = "取消";
// AI使用限制
translations["MSG_QUOTA_EXCEEDED"] = "今天的次數用完啦！明天再來吧！";
translations["MSG_QUOTA_RESET_TIME"] = "明天0:00重置";
translations["MSG_AI_PROCESSING"] = "AI生成中...";

translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "帳號操作";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "變更密碼";
translations["MSG_PARENT_PAGE_LOGOUT"] = "登出";
// 家長頁面 - 暱稱編輯彈窗
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "變更暱稱";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "請輸入新的暱稱";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "請嘗試自我介紹名稱";
// 家長頁面 - 孩子管理標籤頁
translations["MSG_PARENT_PAGE_ADD"] = "新增";
translations["MSG_PARENT_PAGE_ACTIVE"] = "活躍";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非活躍";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "可遊玩";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "已暫停";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切換";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "無法切換";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "此玩家已停用，無法切換登入。請先啟用玩家。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "切換玩家？";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "切換到「%{name}」。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本資訊";
translations["MSG_PARENT_PAGE_AGE"] = "年齡";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "歲";
translations["MSG_PARENT_PAGE_GENDER"] = "性別";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "生日";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "帳號建立日期";
translations["MSG_GENDER_SELECT_TITLE"] = "請選擇一個";
translations["MSG_GENDER_STATUS_LABEL"] = "性別";
translations["MSG_GENDER_NOT_SELECTED"] = "未選擇";
translations["MSG_GENDER_MALE"] = "男孩";
translations["MSG_GENDER_FEMALE"] = "女孩";
translations["MSG_GENDER_NONE"] = "無";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "修改名字";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "請輸入新名字";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "修改性別";
translations["MSG_PARENT_PAGE_GENDER_EDIT_MESSAGE"] = "請選擇性別";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "修改生日";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "課程完成";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "建立的作品";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "已發布作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "獲得的讚";
translations["MSG_PARENT_PAGE_SETTINGS"] = "設定";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "顯示語言";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "平假名";
translations["MSG_PARENT_PAGE_KANJI"] = "漢字";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品公開";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "複製許可";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "與學伴君聊天";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AI創作素材";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "帳號狀態";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危險操作";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "所有學習資料和作品將被刪除。此操作無法撤銷。";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "刪除此使用者";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "刪除";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近活動";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24小時內暫無活動";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24小時的活動";
translations["MSG_PARENT_PAGE_TODAY"] = "今天";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨天";

// 家長頁面 - 活動類型
translations["MSG_ACTIVITY_COURSE_CLEAR"] = "通關%{course}第%{stage}關 第%{level}級！";
translations["MSG_ACTIVITY_PROJECT_CREATED"] = "創建了「%{name}」";
translations["MSG_ACTIVITY_PROJECT_PUBLISHED"] = "發佈了「%{name}」";
translations["MSG_ACTIVITY_PROJECT_FAVORITED"] = "點讚了「%{name}」";
translations["MSG_ACTIVITY_FAVORITED_RECEIVED"] = "收到了一個讚";
translations["MSG_ACTIVITY_LOGIN"] = "登入了";
translations["MSG_ACTIVITY_ICON_CHANGED"] = "更換了頭像";
translations["MSG_ACTIVITY_AI_CHAT"] = "和AI聊天了";
translations["MSG_ACTIVITY_INQUIRY_SENT"] = "發送了問題反饋";
translations["MSG_ACTIVITY_APP_REVIEWED"] = "給應用評了★%{rating}";
translations["MSG_ACTIVITY_FEEDBACK_SENT"] = "發送了回饋";
translations["MSG_ACTIVITY_COIN_EARNED"] = "獲得了%{amount}個金幣";
translations["MSG_ACTIVITY_COIN_SPENT"] = "使用了%{amount}個金幣";
translations["MSG_ACTIVITY_LOGIN_STREAK"] = "連續登入%{days}天！";
translations["MSG_ACTIVITY_DEFAULT"] = "活動";

// 家長頁面 - 活動日誌（家長專用）
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "通過了%{course}的階段%{stage} 等級%{level}！";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "創建了「%{name}」";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "發佈了「%{name}」";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "給「%{name}」點了讚";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "收到了點讚";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "登入了";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "更換了頭像";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "和AI聊天了";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "發送了問題反饋";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "給應用評了★%{rating}";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "發送了回饋";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活動";

// 家長頁面 - 作品・素材部分
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "應用列表";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "還沒有應用";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "還沒有素材";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "查看更多";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "相簿";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "畫板";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI圖片";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "已發佈";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公開";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "次瀏覽";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "個讚";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "次複製";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "建立日期";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日期";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "建立日期";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "尺寸";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "未命名";

// 家長頁面 - 反饋歷史
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "反饋歷史";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "還沒有反饋";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "應用程式評價";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "反饋";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "諮詢";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "給應用程式評了★%{rating}";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使用方法";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "問題回報";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "功能請求";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "自我介紹";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "已回覆";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未回覆";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "反饋詳情";

// 家長頁面 - AI聊天記錄
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "AI聊天記錄";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "暫無聊天記錄";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}則訊息";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "無標題";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "暫無訊息";

// 家長頁面 - 訂閱管理標籤頁
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "目前方案";
translations["MSG_PARENT_PAGE_MONTHLY_PRICE"] = "月費";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "方案比較";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "玩家數";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = "「自由創作」作品數";
translations["MSG_PARENT_PAGE_PROJECTS"] = "個作品";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "與學伴君聊天";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AI素材圖像生成";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "5次/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2次/日";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "與AI角色愉快聊天！";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "回答問題和諮詢";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "培養孩子好奇心的對話體驗";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "可以討論想法";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "將想像變成圖像！";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "創建原創圖標";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "用於「自由創作」";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "也可傳送到聊天";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "無限制";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FEATURE"] = "聊天記錄";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FREE_LIMIT"] = "最多100則";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "無限制";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "無限制";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "無限制（同時生成1張）";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "無限制（同時生成3張）";
translations["MSG_PARENT_PAGE_FREE"] = "免費";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "方案資訊";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "購買方案";
translations["MSG_PARENT_PAGE_SELECT_BILLING_PERIOD"] = "選擇訂閱週期";
translations["MSG_PARENT_PAGE_ANNUAL_PRICE"] = "年費";

// 家長頁面 - 自我介紹標籤頁
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "下載家長應用程式";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] = "使用家長應用程式查看孩子的學習進度並管理設定。";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "學習支援";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "查看課程答案";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "查看教學";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企業合作代碼";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "輸入企業認證代碼";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] = "如果您有企業合作代碼，請在這裡輸入。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "如果您持有「樂學拼圖」認證碼（企業合作碼），請在下方輸入指定的代碼。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "輸入認證碼";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "確定";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "已授權的內容（卡帶）";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] = "沒有已授權的追加內容（卡帶）。";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
// 家長頁面 - 通知標籤頁（示範資料）
// AI預設
translations["MSG_AI_PRESET_CAT"] = "貓";
translations["MSG_AI_PRESET_DOG"] = "狗";
translations["MSG_AI_PRESET_RABBIT"] = "兔";
translations["MSG_AI_PRESET_BEAR"] = "熊";
translations["MSG_AI_PRESET_BIRD"] = "鳥";
translations["MSG_AI_PRESET_NINJA"] = "忍者";
translations["MSG_AI_PRESET_WIZARD"] = "魔法師";
translations["MSG_AI_PRESET_ROBOT"] = "機器人";

// AI生成選項（家長）
translations["MSG_OPTIONAL"] = "可選";
translations["MSG_REQUIRED"] = "必填";
// AI風格（9種）
translations["MSG_AI_STYLE_CYBERPUNK"] = "賽博龐克";
translations["MSG_AI_STYLE_ANIME"] = "動漫";
translations["MSG_AI_STYLE_DRAMATIC"] = "戲劇性肖像";
translations["MSG_AI_STYLE_COLORING"] = "塗色書";
translations["MSG_AI_STYLE_PHOTO"] = "攝影";
translations["MSG_AI_STYLE_RETRO_MANGA"] = "復古漫畫";
translations["MSG_AI_STYLE_EIGHTIES"] = "80年代魅力";
translations["MSG_AI_STYLE_ART_NOUVEAU"] = "新藝術風格";
translations["MSG_AI_STYLE_SYNTHWAVE"] = "合成器波";

// AI表情（4種）
translations["MSG_AI_EXPRESSION_SMILE"] = "微笑";
translations["MSG_AI_EXPRESSION_COOL"] = "酷";
translations["MSG_AI_EXPRESSION_SLEEPY"] = "睏倦";
translations["MSG_AI_EXPRESSION_SURPRISED"] = "驚訝";

// AI配飾（4種）
translations["MSG_AI_ACCESSORY_HAT"] = "帽子";
translations["MSG_AI_ACCESSORY_GLASSES"] = "眼鏡";
translations["MSG_AI_ACCESSORY_RIBBON"] = "蝴蝶結";
translations["MSG_AI_ACCESSORY_CROWN"] = "皇冠";

// AI背景（4種）
translations["MSG_AI_BACKGROUND_STARRY"] = "星空";
translations["MSG_AI_BACKGROUND_MEADOW"] = "草原";
translations["MSG_AI_BACKGROUND_SPACE"] = "宇宙";
translations["MSG_AI_BACKGROUND_FLOWER"] = "花海";

// AI加工 - 類型
// AI加工 - 步驟標題
// AI加工 - 風格選項
// AI加工 - 背景選項
// AI加工 - 扮演選項
// AI加工 - 動物選項
// AI加工 - 配飾選項
// AI加工 - 季節選項
translations["MSG_TOAST_AI_GENERATION_FAILED"] = "AI圖像生成失敗。";
// AIImageModal
translations["MSG_AI_IMAGE_SAVED"] = "AI圖像已保存到素材庫";
translations["MSG_AI_TAB_GENERATE"] = "生成";
// CreateUserWizard - 按鈕
translations["MSG_CREATE_USER_BTN_NEXT"] = "下一步";
translations["MSG_CREATE_USER_BTN_GENERATE"] = "建立頭像";
// CreateUserWizard - 個人資料輸入子步驟名稱
translations["MSG_PROFILE_SUBSTEP_GENDER"] = "性別";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY"] = "生日";
translations["MSG_PROFILE_SUBSTEP_FAVORITES"] = "喜好";
translations["MSG_PROFILE_SUBSTEP_ICON"] = "頭像";
translations["MSG_ICON_GENERATING"] = "正在根據個人資料\n製作頭像...";
translations["MSG_ICON_CONFIRM_PROMPT"] = "這個頭像可以嗎？";
translations["MSG_ICON_CONFIRM_BTN"] = "好的！";
translations["MSG_ICON_REGENERATE_BTN"] = "再試一次";
translations["MSG_ICON_CREATE_BTN"] = "建立";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "如果想添加什麼";
translations["MSG_ICON_ADDITIONAL_PROMPT_HINT"] = "輸入喜歡的顏色或東西，再做一個新頭像！";

// CreateUserWizard - 個人資料輸入標題
// CreateUserWizard - 自我介紹
// CreateUserWizard - 步驟標題（兒童用基礎）
translations["MSG_CREATE_USER_TITLE_GENDER"] = "你是哪個？";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY"] = "你的生日是什麼時候？";
translations["MSG_CREATE_USER_TITLE_PREVIEW"] = "這樣可以嗎？";

// CreateUserWizard - 家長用/添加兒童用文案
// CreateUserWizard - 家長用按鈕
// CreateUserWizard - 上傳頭像（家長用）
translations["MSG_ICON_SELECT_UPLOAD"] = "上傳圖片";
translations["MSG_UPLOAD_ICON_TITLE"] = "上傳圖片";
translations["MSG_UPLOAD_ICON_SELECT"] = "選擇圖片";
translations["MSG_UPLOAD_ICON_HINT"] = "JPG、PNG格式，最大5MB";
translations["MSG_UPLOAD_ICON_CHANGE"] = "更換圖片";
translations["MSG_UPLOAD_ICON_REMOVE"] = "刪除圖片";
// CreateUserWizard - 職業步驟（家長用）
// 個人資料標籤
translations["MSG_PROFILE_TAB_BASIC"] = "基本";
translations["MSG_PROFILE_TAB_APPEARANCE"] = "頭像";
translations["MSG_PROFILE_TAB_FAVORITES"] = "個性";
translations["MSG_PROFILE_TAB_GAME_CASE"] = "遊戲\n外殼";
translations["MSG_PROFILE_MULTI_SELECT"] = "可以選多個喔";
translations["MSG_PROFILE_NOT_SET"] = "還沒選喔";
translations["MSG_PROFILE_SELF_INTRODUCTION_NOT_SET"] = "還沒輸入喔";
translations["MSG_PROFILE_CHANGE_BTN"] = "更改";
translations["MSG_PROFILE_EDIT_COLOR_TITLE"] = "選擇喜歡的顏色";
translations["MSG_PROFILE_EDIT_BEST_SUBJECTS_TITLE"] = "選擇你擅長的科目";
translations["MSG_SELECT_PLACEHOLDER"] = "請選擇";

// CreateUserWizard - 喜好步驟
translations["MSG_PROFILE_AI_FAVORITE_COLOR"] = "喜歡的顏色";
translations["MSG_PROFILE_AI_FAVORITE_ANIMAL"] = "喜歡的動物";
translations["MSG_PROFILE_AI_FAVORITE_FOOD"] = "喜歡的食物";
translations["MSG_PROFILE_AI_STRENGTH"] = "擅長什麼";
translations["MSG_PROFILE_AI_OTHER_INFO"] = "自我介紹";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER"] = "告訴我們關於你的事情";
translations["MSG_PROFILE_AI_BEST_SUBJECTS"] = "擅長的科目";
translations["MSG_PROFILE_AI_GLASSES"] = "眼鏡";
translations["MSG_PROFILE_AI_ACCESSORY"] = "配飾";
translations["MSG_PROFILE_AI_HAIRSTYLE"] = "髮型";
translations["MSG_PROFILE_AI_BODY_TYPE"] = "體型";
translations["MSG_PROFILE_AI_FACE_SHAPE"] = "臉型";
translations["MSG_PROFILE_EDIT_ACCESSORY_TITLE"] = "選擇配飾";
// 配飾選項
translations["MSG_ACCESSORY_NONE"] = "無";
translations["MSG_ACCESSORY_MEGANE"] = "眼鏡";
translations["MSG_ACCESSORY_BOUSHI"] = "帽子";
translations["MSG_ACCESSORY_HAIRPIN"] = "髮夾";
translations["MSG_ACCESSORY_RIBBON"] = "蝴蝶結";
translations["MSG_ACCESSORY_BANDAID"] = "創可貼";

// 顏色
translations["MSG_COLOR_RED"] = "紅色";
translations["MSG_COLOR_BLUE"] = "藍色";
translations["MSG_COLOR_PINK"] = "粉紅色";
translations["MSG_COLOR_GREEN"] = "綠色";
translations["MSG_COLOR_YELLOW"] = "黃色";
translations["MSG_COLOR_PURPLE"] = "紫色";
translations["MSG_COLOR_WHITE"] = "白色";

// 顏色選擇UI
translations["MSG_COLOR_SELECT_SHADE"] = "選擇你喜歡的色調";

// 動物
translations["MSG_ANIMAL_CAT"] = "貓";
translations["MSG_ANIMAL_DOG"] = "狗";
translations["MSG_ANIMAL_RABBIT"] = "兔子";
translations["MSG_ANIMAL_BEAR"] = "熊";
translations["MSG_ANIMAL_BIRD"] = "鳥";
translations["MSG_ANIMAL_DINOSAUR"] = "恐龍";

// 食物
translations["MSG_FOOD_CURRY"] = "咖哩";
translations["MSG_FOOD_RAMEN"] = "拉麵";
translations["MSG_FOOD_SUSHI"] = "壽司";
translations["MSG_FOOD_HAMBURGER"] = "漢堡";
translations["MSG_FOOD_PIZZA"] = "披薩";
translations["MSG_FOOD_ICE_CREAM"] = "冰淇淋";
translations["MSG_FOOD_FRUIT"] = "水果";
translations["MSG_FOOD_CAKE"] = "蛋糕";

// 特長
translations["MSG_STRENGTH_SPORTS"] = "運動";
translations["MSG_STRENGTH_DRAWING"] = "畫畫";
translations["MSG_STRENGTH_MUSIC"] = "音樂";
translations["MSG_STRENGTH_READING"] = "閱讀";
translations["MSG_STRENGTH_MATH"] = "數學";
translations["MSG_STRENGTH_GAMES"] = "遊戲";
translations["MSG_STRENGTH_CRAFTS"] = "手工";
translations["MSG_STRENGTH_COOKING"] = "烹飪";

// 興趣
translations["MSG_INTEREST_PROGRAMMING"] = "程式設計";
translations["MSG_INTEREST_SCIENCE"] = "科學";
translations["MSG_INTEREST_ART"] = "藝術";
translations["MSG_INTEREST_MUSIC"] = "音樂";
translations["MSG_INTEREST_SPORTS"] = "運動";
translations["MSG_INTEREST_NATURE"] = "自然";
translations["MSG_INTEREST_SPACE"] = "太空";
translations["MSG_INTEREST_ANIMALS"] = "動物";

// 科目
translations["MSG_SUBJECT_LANGUAGE"] = "國語";
translations["MSG_SUBJECT_MATH"] = "數學";
translations["MSG_SUBJECT_SCIENCE"] = "科學";
translations["MSG_SUBJECT_SOCIAL"] = "社會";
translations["MSG_SUBJECT_MUSIC"] = "音樂";
translations["MSG_SUBJECT_ART"] = "美術";
translations["MSG_SUBJECT_PE"] = "體育";
translations["MSG_SUBJECT_LIFE"] = "生活";
translations["MSG_SUBJECT_HOME_EC"] = "家政";
translations["MSG_SUBJECT_ETHICS"] = "道德";
translations["MSG_SUBJECT_ENGLISH"] = "英語";
translations["MSG_SUBJECT_INTEGRATED"] = "綜合";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES"] = "活動";

// 擅長科目（家長用）

// 外觀選項
translations["MSG_GLASSES_NONE"] = "無";
translations["MSG_GLASSES_YES"] = "有";
translations["MSG_HAIRSTYLE_VERY_SHORT"] = "很短";
translations["MSG_HAIRSTYLE_SHORT"] = "短";
translations["MSG_HAIRSTYLE_MEDIUM"] = "中等";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG"] = "略長";
translations["MSG_HAIRSTYLE_LONG"] = "長";
translations["MSG_BODY_TYPE_THIN"] = "瘦";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN"] = "偏瘦";
translations["MSG_BODY_TYPE_MEDIUM"] = "中等";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY"] = "微胖";
translations["MSG_BODY_TYPE_CHUBBY"] = "偏胖";
translations["MSG_FACE_SHAPE_ROUND"] = "圓臉";
translations["MSG_FACE_SHAPE_OVAL"] = "鵝蛋臉";
translations["MSG_FACE_SHAPE_OBLONG"] = "長臉";
translations["MSG_FACE_SHAPE_SQUARE"] = "方臉";
translations["MSG_FACE_SHAPE_TRIANGLE"] = "三角臉";

// CreateUserWizard - 家長用步驟名稱
// CreateUserWizard - 個人資料子步驟（家長用）
// CreateUserWizard - 生日分步選擇（兒童用）
translations["MSG_BIRTHDAY_YEAR_SUFFIX"] = "年";
translations["MSG_BIRTHDAY_MONTH_SUFFIX"] = "月";
translations["MSG_BIRTHDAY_DAY_SUFFIX"] = "日";
// 頁腳按鈕
// NameInputStep
// PresetIconStep 標籤
// BirthdayStep 後綴
// FavoritesStep
// 顏色選項
// 動物選項
// 食物選項
// 特長選項
// 興趣選項
// IconPreviewStep
// StepProgressBar
// ProfileSubStepBar

// AI Image Generation - Usage count (FREE)
translations["MSG_AI_IMAGE_PLAN_LABEL"] = "方案";
translations["MSG_AI_IMAGE_USAGE_TODAY"] = "今天 %{remaining}/%{limit}次";
translations["MSG_AI_IMAGE_UNLIMITED"] = "無限使用";
translations["MSG_AI_IMAGE_COUNT_PER_REQUEST"] = "每次%{count}張";

// ParentOnboardingModal - 家長引導
translations["MSG_PARENT_ONBOARDING_NAME_PLACEHOLDER"] = "暱稱";
translations["MSG_PARENT_ONBOARDING_NICKNAME_TITLE"] = "請輸入暱稱";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_LIMIT"] = "最多10個字元";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_ERROR"] = "請輸入10個字元以內";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "預設\n頭像";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "請選擇頭像";
translations["MSG_PARENT_ONBOARDING_REGION_TITLE"] = "您的所在地區";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "檔案太大";

// CreateUserWizard - 個人資料「自我介紹」輸入欄

translations["MSG_ICON_SELECT_TITLE"] = "選擇你的頭像！";
translations["MSG_ICON_SELECT_SYSTEM"] = "預設\n頭像";
translations["MSG_ICON_SELECT_SYSTEM_DESC"] = "從各種角色中選擇";
translations["MSG_ICON_SELECT_PROFILE_AI"] = "用AI從\n個人資料\n創建";
translations["MSG_ICON_SELECT_PROFILE_AI_DESC"] = "輸入你的喜好我們會創建";
translations["MSG_ICON_SELECT_MATERIAL"] = "從素材\n中選擇";
translations["MSG_ICON_SELECT_MATERIAL_DESC"] = "你也可以上傳圖片";
translations["MSG_SYSTEM_ICON_TITLE"] = "從預設中選擇";
translations["MSG_ICON_CATEGORY_ALL"] = "全部";
translations["MSG_ICON_CATEGORY_BOY"] = "男孩";
translations["MSG_ICON_CATEGORY_GIRL"] = "女孩";
translations["MSG_PROFILE_AI_APPEARANCE"] = "外貌";
translations["MSG_PROFILE_AI_BEST_SUBJECT"] = "擅長科目";
translations["MSG_GLASSES_TITLE"] = "眼鏡";
translations["MSG_HAIRSTYLE_TITLE"] = "髮型";
translations["MSG_BODY_TYPE_TITLE"] = "體型";
translations["MSG_FACE_SHAPE_TITLE"] = "臉型";
translations["MSG_CREATE_USER_STEP_NAME"] = "名字";
translations["MSG_CREATE_USER_STEP_ICON"] = "頭像";
translations["MSG_CREATE_USER_STEP_CONFIRM"] = "確認";
translations["MSG_REGENERATE_BTN"] = "重新創建";
translations["MSG_PROFILE_AI_GENERATE_BTN"] = "創建頭像！";
translations["MSG_PROFILE_AI_GENERATING"] = "正在創建...";
translations["MSG_PROFILE_AI_GENDER_TITLE"] = "性別";
translations["MSG_PROFILE_AI_OPTIONS_TITLE"] = "偏好";
translations["MSG_PROFILE_AI_BIRTHDAY_TITLE"] = "生日";
translations["MSG_PROFILE_AI_BIRTHDAY_SELECT"] = "選擇";
translations["MSG_PROFILE_AI_OCCUPATION"] = "職業";
translations["MSG_PROFILE_AI_OCCUPATION_PLACEHOLDER"] = "例如：上班族、自由職業";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "喜歡的顏色";
translations["MSG_AI_MATERIAL_MODAL_TITLE"] = "創建AI圖像！";
translations["MSG_AI_MATERIAL_PROMPT_LABEL"] = "創建什麼？";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_1"] = "可愛的狗";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_2"] = "開心地跑";
translations["MSG_AI_MATERIAL_GENERATE_BUTTON"] = "創建！";
translations["MSG_AI_EDUCATION_LIMIT_TITLE"] = "不可用";
translations["MSG_AI_EDUCATION_LIMIT_MESSAGE"] = "教室計劃中無法使用此功能";
translations["MSG_USER_STOCK_AI_TAB"] = "AI工作室";
translations["MSG_USER_STOCK_AI_TITLE"] = "AI工作室";
translations["MSG_USER_STOCK_AI_HINT"] = "用AI創建的圖像";
translations["MSG_USER_STOCK_AI_EMPTY"] = "還沒有AI圖像";
translations["MSG_USER_PROFILE_EDIT_BTN"] = "編輯";
translations["MSG_TOAST_PROJECT_QUOTA_EXCEEDED"] = "已達到應用上限";
translations["MSG_CREATOR_APP_LIMIT"] = "無法創建應用";
translations["MSG_CREATOR_APP_LIMIT_TITLE"] = "無法創建應用";
translations["MSG_CREATOR_APP_LIMIT_MESSAGE"] =
  "當前方案最多可創建%{limit}個應用\n如需創建新應用，請刪除已有應用";
translations["MSG_CREATOR_TUTORIAL_LIMIT"] = "無法運行指南";
translations["MSG_CREATOR_TUTORIAL_LIMIT_TITLE"] = "無法運行指南";
translations["MSG_CREATOR_TUTORIAL_LIMIT_MESSAGE"] =
  "當前方案最多可創建%{limit}個應用\n如需運行指南，請刪除已有應用";
translations["MSG_TOAST_AI_QUOTA_EXCEEDED"] = "今天的AI已用完";
translations["MSG_TOAST_AI_ACCESS_DENIED"] = "此功能不可用";
translations["MSG_TOAST_ERROR"] = "發生錯誤";
translations["MSG_ERROR_NETWORK"] = "網路錯誤";
translations["MSG_GENDER_MALE_PARENT"] = "男";
translations["MSG_GENDER_FEMALE_PARENT"] = "女";
translations["MSG_GENDER_OTHER_PARENT"] = "其他";
translations["MSG_GENDER_PREFER_NOT_TO_SAY"] = "不願透露";
translations["MSG_GENDER_NOT_SPECIFIED"] = "未指定";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "當前";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "已選擇";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "更改語言";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "選擇顯示語言";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "編輯擅長科目";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "編輯眼鏡";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "編輯髮型";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "編輯體型";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "編輯臉型";
translations["MSG_SUBJECT_JAPANESE"] = "日語";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "無法添加用戶";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "目前方案最多可新增{{limit}}位使用者。\n升級方案後可新增更多使用者。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "刪除用戶？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}} 被刪除後，此使用者的所有資料（進度、作品等）將會消失。\n此操作無法復原。";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "無法刪除用戶";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "至少需要 1 位使用者。\n刪除前請先新增另一位使用者。";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "訂閱管理";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] = "請在App Store管理您購買的訂閱";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] = "請在Google Play管理您購買的訂閱";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "在其他平台購買";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] = "此訂閱是在其他平台購買的";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "計費週期";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月付";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年付";
translations["MSG_SUBSCRIPTION_MANAGE"] = "管理訂閱";
translations["MSG_SUBSCRIPTION_COMPARISON_RECOMMENDED"] = "推薦";
translations["MSG_PARENT_ONBOARDING_STEP_NAME"] = "名字";
translations["MSG_PARENT_ONBOARDING_STEP_ICON"] = "頭像";
translations["MSG_PARENT_ONBOARDING_STEP_COMPLETE"] = "確認";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "頭像";
translations["MSG_PARENT_PROFILE_WORK"] = "工作";
translations["MSG_PARENT_PROFILE_REGION"] = "地區";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家庭";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "媽媽";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "爸爸";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "奶奶";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "爺爺";
translations["MSG_COMPANY_SIZE_TITLE"] = "公司規模";
translations["MSG_COMPANY_SIZE_SOLO"] = "個人事業主";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10人";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50人";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300人";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000人";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001人以上";
translations["MSG_INDUSTRY_TITLE"] = "行業";
translations["MSG_INDUSTRY_IT"] = "IT・通訊";
translations["MSG_INDUSTRY_MANUFACTURING"] = "製造業";
translations["MSG_INDUSTRY_FINANCE"] = "金融・保險";
translations["MSG_INDUSTRY_RETAIL"] = "零售・批發";
translations["MSG_INDUSTRY_HEALTHCARE"] = "醫療・福利";
translations["MSG_INDUSTRY_EDUCATION"] = "教育";
translations["MSG_INDUSTRY_GOVERNMENT"] = "政府機關・公務員";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "不動產";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "建設";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "運輸・物流";
translations["MSG_INDUSTRY_MEDIA"] = "媒體・廣告";
translations["MSG_INDUSTRY_SERVICE"] = "服務業";
translations["MSG_INDUSTRY_OTHER"] = "其他";
translations["MSG_OCCUPATION_TITLE"] = "職業";
translations["MSG_OCCUPATION_EXECUTIVE"] = "經營者・高階主管";
translations["MSG_OCCUPATION_MANAGER"] = "管理職";
translations["MSG_OCCUPATION_ENGINEER"] = "工程師・技術職";
translations["MSG_OCCUPATION_SALES"] = "業務";
translations["MSG_OCCUPATION_MARKETING"] = "行銷";
translations["MSG_OCCUPATION_HR"] = "人事";
translations["MSG_OCCUPATION_ACCOUNTING"] = "會計・財務";
translations["MSG_OCCUPATION_RESEARCHER"] = "研究職";
translations["MSG_OCCUPATION_TEACHER"] = "教師";
translations["MSG_OCCUPATION_DOCTOR"] = "醫師";
translations["MSG_OCCUPATION_NURSE"] = "護理師";
translations["MSG_OCCUPATION_LAWYER"] = "律師";
translations["MSG_OCCUPATION_DESIGNER"] = "設計師";
translations["MSG_OCCUPATION_FREELANCE"] = "自由工作者";
translations["MSG_OCCUPATION_HOMEMAKER"] = "專職主婦・主夫";
translations["MSG_OCCUPATION_STUDENT"] = "學生";
translations["MSG_OCCUPATION_OTHER"] = "其他";
translations["MSG_JOB_TITLE_LABEL"] = "職位";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "經營者・高管";
translations["MSG_JOB_TITLE_MANAGER"] = "管理職";
translations["MSG_JOB_TITLE_GENERAL"] = "一般職員";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "專業職";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "無職位（家庭主婦／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "無職位（學生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "無職位（無業）";
translations["MSG_PREFECTURE_TITLE"] = "省份";
translations["MSG_CITY_TITLE"] = "城市";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "家庭成員";
translations["MSG_BOYS_COUNT"] = "男孩";
translations["MSG_GIRLS_COUNT"] = "女孩";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "年收入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "500萬日圓以下";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "500-1000萬日圓";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "1000萬日圓以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "不願透露";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_TITLE"] = "自我介紹";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_PLACEHOLDER"] = "愛好、特長、孩子年齡等";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_SINGLE"] = "單親";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_COUPLE"] = "夫妻";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_NUCLEAR"] = "核心家庭";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_EXTENDED"] = "大家庭";
translations["MSG_PARENT_ONBOARDING_HOBBIES_SPORTS"] = "運動";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MUSIC"] = "音樂";
translations["MSG_PARENT_ONBOARDING_HOBBIES_READING"] = "閱讀";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TRAVEL"] = "旅行";
translations["MSG_PARENT_ONBOARDING_HOBBIES_COOKING"] = "烹飪";
translations["MSG_PARENT_ONBOARDING_HOBBIES_GAMING"] = "遊戲";
translations["MSG_PARENT_ONBOARDING_HOBBIES_OUTDOOR"] = "戶外";
translations["MSG_PARENT_ONBOARDING_HOBBIES_ART"] = "藝術";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MOVIES"] = "電影";
translations["MSG_PARENT_ONBOARDING_HOBBIES_PHOTOGRAPHY"] = "攝影";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女";
translations["MSG_PARENT_ONBOARDING_GENDER_NONE"] = "未指定";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "選擇頭像方式";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "上傳\n圖片";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "AI自動從\n個人資料\n生成";
translations["MSG_PARENT_ONBOARDING_GENDER_TITLE"] = "性別";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_TITLE"] = "生日";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "選擇";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "上傳圖片";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "選擇圖片";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG格式，最大5MB";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_TITLE"] = "職業（可選）";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_OPTIONAL"] = "可選";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_PLACEHOLDER"] = "例如：上班族";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_TITLE"] = "公司";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_PLACEHOLDER"] = "公司名稱";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_TITLE"] = "職位";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_PLACEHOLDER"] = "例如：經理";
translations["MSG_PARENT_ONBOARDING_FAMILY_TITLE"] = "家庭結構";
translations["MSG_PARENT_ONBOARDING_CHILDREN_COUNT_TITLE"] = "子女數量";
translations["MSG_PARENT_ONBOARDING_SPOUSE_TITLE"] = "配偶";
translations["MSG_PARENT_ONBOARDING_SPOUSE_YES"] = "是";
translations["MSG_PARENT_ONBOARDING_SPOUSE_NO"] = "否";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TITLE"] = "愛好";
translations["MSG_PARENT_ONBOARDING_HOBBIES_HINT"] = "選擇所有適用的";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "正在創建頭像...";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "這個頭像可以嗎？";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "下一步";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "創建";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "重新創建";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "確認";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "返回";
translations["MSG_PARENT_ONBOARDING_BTN_COMPLETE"] = "完成";

// 家長頁面 - 聊天圖片功能限制
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "關於圖片功能";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "發送圖片需要「特別計劃」\n升級到特別計劃後可以發送圖片";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "查看計劃";

translations["MSG_AI_LABEL"] = "AI";
translations["MSG_BUILDER_AI_GENERATE_BTN"] = "自動生成";
translations["MSG_BUILDER_MAP_NAME_PLACEHOLDER"] = "拼圖名稱";
translations["MSG_BUILDER_TEST_BTN"] = "測試";
translations["MSG_BUILDER_ASSET_LIST_TITLE"] = "選擇方塊";
translations["MSG_BUILDER_ASSET_LIST_SHORT"] = "全部";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION"] = "裝飾";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND"] = "地面";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND_HINT"] = "可以走在上面。階梯可以跳上去。";
translations["MSG_BUILDER_ASSET_CATEGORY_WATER"] = "水";
translations["MSG_BUILDER_ASSET_CATEGORY_WATER_HINT"] = "會掉下去。請跳過去。";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION_HINT"] = "無法通過。請繞道。";
translations["MSG_BUILDER_ASSET_CATEGORY_GEM"] = "物品";
translations["MSG_BUILDER_ASSET_CATEGORY_GEM_HINT"] = "把它們全部收集起來。";
translations["MSG_BUILDER_ASSET_PLACE_ON_TILE"] = "可以放在地圖的方格上";
translations["MSG_BUILDER_ASSET_PLACE_ON_GROUND"] = "可以放在地面上";
translations["MSG_BUILDER_ASSET_CATEGORY_BUTTON"] = "開關";
translations["MSG_BUILDER_ASSET_CATEGORY_BUTTON_HINT"] = "依顏色區分。踩上去會改變高度。";
translations["MSG_BUILDER_COMMAND_SETTINGS_TITLE"] = "可用命令";
translations["MSG_BUILDER_COMMAND_CATEGORY_MOTION"] = "動作";
translations["MSG_BUILDER_COMMAND_CATEGORY_CONTROL"] = "迴圈";
translations["MSG_BUILDER_COMMAND_MOVE_FORWARD"] = "向前移動";
translations["MSG_BUILDER_COMMAND_TURN_LEFT"] = "向左轉";
translations["MSG_BUILDER_COMMAND_TURN_RIGHT"] = "向右轉";
translations["MSG_BUILDER_COMMAND_JUMP"] = "跳躍";
translations["MSG_BUILDER_COMMAND_LOOP"] = "重複○次";
translations["MSG_BUILDER_COMMAND_IF_COLOR"] = "如果顏色是○";
translations["MSG_BUILDER_COMMAND_WHILE_COLOR"] = "重複直到顏色為○";
translations["MSG_BUILDER_COMMAND_SELECTED_COUNT"] = "已選擇%{count}個命令";
translations["MSG_BUILDER_COMMAND_LIMIT_UNLIMITED"] = "無限制";
translations["MSG_BUILDER_COMMAND_LIMIT_COUNT"] = "最多%{count}個";
translations["MSG_BUILDER_PREVIEW_REMAINING"] = "剩餘";
translations["MSG_BUILDER_PREVIEW_UNLIMITED"] = "不限";
translations["MSG_OK_BTN"] = "OK";
translations["MSG_BUILDER_AI_MAP_TITLE"] = "用AI製作地圖";
translations["MSG_BUILDER_AI_PROMPT_LABEL"] = "想做什麼樣的地圖？（可不填）";
translations["MSG_BUILDER_AI_PROMPT_PLACEHOLDER"] = "例如：像迷宮一樣的關卡";
translations["MSG_BUILDER_DIFFICULTY_LABEL"] = "難度";
translations["MSG_BUILDER_DIFFICULTY_EASY"] = "簡單";
translations["MSG_BUILDER_DIFFICULTY_MEDIUM"] = "普通";
translations["MSG_BUILDER_DIFFICULTY_HARD"] = "困難";
translations["MSG_BUILDER_AI_GENERATING"] = "正在生成...";
translations["MSG_BUILDER_AI_GENERATION_FAILED"] = "地圖生成失敗";
// 拼圖編輯器: PublishStepsPanel (spec §5.8.3)
translations["MSG_BUILDER_PUBLISH_PANEL_TITLE"] = "完成準備";
translations["MSG_BUILDER_PUBLISH_PROGRESS_DONE"] = "這就完成囉！";
translations["MSG_BUILDER_STEP_CHARACTER"] = "角色";
translations["MSG_BUILDER_STEP_GOAL"] = "終點";
translations["MSG_BUILDER_STEP_COMMANDS"] = "命令";
translations["MSG_BUILDER_STEP_TEST"] = "測試";
translations["MSG_BUILDER_STEP_META"] = "拼圖資訊";
translations["MSG_BUILDER_META_NAME_LABEL"] = "名稱";
translations["MSG_BUILDER_META_DESC_LABEL"] = "說明";
translations["MSG_BUILDER_META_DESC_PLACEHOLDER"] = "介紹一下你的拼圖吧";
translations["MSG_BUILDER_META_DESC_MIN"] = "還差%{count}個字";
translations["MSG_BUILDER_META_DETAIL_BTN"] = "詳細";
translations["MSG_BUILDER_STEP_COMMANDS_COUNT"] = "已設定%{count}個";
translations["MSG_BUILDER_STEP_BTN_PLACE"] = "放置";
translations["MSG_BUILDER_STEP_BTN_SETTING"] = "設定";
translations["MSG_BUILDER_STEP_BTN_RETRY"] = "再來一次";
translations["MSG_BUILDER_STEP_BTN_EDIT"] = "編輯";
translations["MSG_BUILDER_EDIT_HISTORY"] = "查看紀錄";
translations["MSG_BUILDER_EDIT_HISTORY_SHORT"] = "紀錄";
translations["MSG_BUILDER_SELECTED_ASSET"] = "選取中的方塊";
translations["MSG_BUILDER_EDIT_HISTORY_EMPTY"] = "還沒有紀錄";
translations["MSG_BUILDER_EDIT_HISTORY_RESTORE"] = "還原";
translations["MSG_BUILDER_EDIT_HISTORY_NOW"] = "現在";
translations["MSG_BUILDER_EDIT_HISTORY_RESTORE_CONFIRM_TITLE"] = "要恢復到這個時候嗎？";
translations["MSG_BUILDER_EDIT_HISTORY_RESTORE_CONFIRM_MSG"] =
  "恢復到「%{time}」的時候。\n現在的內容也會留在紀錄裡，之後還能恢復。";
translations["MSG_BUILDER_HISTORY_ACTION_PLACE_ASSET"] = "放置了方塊";
translations["MSG_BUILDER_HISTORY_ACTION_REMOVE_ASSET"] = "刪除了方塊";
translations["MSG_BUILDER_HISTORY_ACTION_RESIZE_MAP"] = "改變了大小";
translations["MSG_BUILDER_HISTORY_ACTION_SET_GOAL"] = "設定了終點";
translations["MSG_BUILDER_HISTORY_ACTION_SET_CHARACTER"] = "放置了角色";
translations["MSG_BUILDER_HISTORY_ACTION_AI_GENERATE"] = "用AI製作";
translations["MSG_BUILDER_HISTORY_ACTION_RENAME"] = "修改了名稱";
translations["MSG_BUILDER_HISTORY_ACTION_RESTORE"] = "已還原到此處";
translations["MSG_BUILDER_HISTORY_EVENT_COMPLETE"] = "完成";
translations["MSG_BUILDER_HISTORY_EVENT_PUBLISH"] = "已公開";
translations["MSG_BUILDER_HISTORY_EVENT_UNPUBLISH"] = "已取消公開";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_ASSET"] = "修改了方塊";
translations["MSG_BUILDER_HISTORY_ACTION_UNDO"] = "復原了";
translations["MSG_BUILDER_HISTORY_ACTION_REDO"] = "重做了";
translations["MSG_BUILDER_HISTORY_ACTION_UNDO_OF"] = "復原了：%{action}";
translations["MSG_BUILDER_HISTORY_ACTION_REDO_OF"] = "重做了：%{action}";
translations["MSG_BUILDER_HISTORY_EVENT_OPEN"] = "打開了拼圖";
translations["MSG_BUILDER_HISTORY_EVENT_CLOSE"] = "關閉了拼圖";
translations["MSG_BUILDER_HISTORY_EVENT_DISCARD"] = "放棄了草稿";
translations["MSG_BUILDER_HISTORY_EVENT_TEST"] = "測試了";
translations["MSG_BUILDER_HISTORY_EVENT_AUTO"] = "中途的紀錄";
translations["MSG_BUILDER_HISTORY_EVENT_BEFORE_RESTORE"] = "恢復之前";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_DESC"] = "修改了說明";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_HINTS"] = "修改了提示";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_COVER"] = "更換了封面";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_BACKGROUND"] = "更換了背景";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_COMMANDS"] = "修改了可用命令";
translations["MSG_BUILDER_TOAST_RESTORED"] = "已恢復到「%{time}」的時候";
translations["MSG_BUILDER_EDIT_HISTORY_LIMIT_NOTE"] = "可以查看最近 %{limit} 次（共 %{total} 次）";
translations["MSG_BUILDER_COMPLETE_BTN"] = "完成！";
translations["MSG_BUILDER_INCOMPLETE_BTN"] = "尚未完成";
translations["MSG_BUILDER_PUBLISH_SHARE_BTN"] = "公開給大家";
translations["MSG_BUILDER_KEEP_DRAFT_BTN"] = "繼續製作";
translations["MSG_BUILDER_PUBLISH_HINT"] = "公開後\n其他人就能玩了";
translations["MSG_BUILDER_UNPUBLISH_HINT"] = "取消公開後\n其他人就不能玩了";
translations["MSG_BUILDER_TEST_SUCCESS_BACK_BTN"] = "返回編輯";
translations["MSG_BUILDER_PREVIEW_SUCCESS_BACK_BTN"] = "返回列表";
translations["MSG_BUILDER_PUBLISH_OPTION_COPY"] = "允許複製";
translations["MSG_BUILDER_PUBLISH_OPTION_COMMENT"] = "允許留言";
translations["MSG_BUILDER_PUBLISH_DENIED_TITLE"] = "需要家長許可";
translations["MSG_BUILDER_CREATE_DENIED_TITLE"] = "拼圖只能做1個";
translations["MSG_BUILDER_CREATE_DENIED_MESSAGE"] =
  "還沒有註冊時，只能做1個拼圖。\n想做更多，請先完成守護設定。";
translations["MSG_BUILDER_PUBLISH_DENIED_MESSAGE"] =
  "公開作品需要家長的許可。\n可以在家長頁面進行設定。";
translations["MSG_BUILDER_COMPLETE_TOAST"] = "完成了！";
translations["MSG_BUILDER_COMPLETE_FAILED"] = "還有沒完成的地方喔";
translations["MSG_BUILDER_LOAD_FAILED"] = "無法讀取作品。";
translations["MSG_BUILDER_ACTION_FAILED"] = "操作失敗了，請再試一次。";
// 拼圖編輯器: 草稿編輯 (spec §5.8.7/§5.8.8)
translations["MSG_BUILDER_DRAFT_EDITING_PILL"] = "草稿編輯中";
translations["MSG_BUILDER_DISCARD_DRAFT_BTN"] = "捨棄草稿";
translations["MSG_BUILDER_DISCARD_DRAFT_CONFIRM"] = "要停止編輯嗎？";
// 拼圖編輯器: AIChatModal (spec §5.8.5)
translations["MSG_BUILDER_AI_CHAT_TITLE"] = "用AI製作";
translations["MSG_BUILDER_AI_CHAT_SUBTITLE"] = "透過對話製作地圖";
translations["MSG_BUILDER_AI_GREETING"] = "要做什麼樣的地圖？";
translations["MSG_BUILDER_AI_PLAN_LABEL"] = "方案 %{n}";
translations["MSG_BUILDER_AI_USE_THIS"] = "使用這個";
translations["MSG_BUILDER_AI_REGENERATE"] = "再來3個方案";
translations["MSG_BUILDER_AI_RECOMMENDED"] = "（推薦）";
translations["MSG_BUILDER_AI_SESSION_EXPIRED"] = "之前的對話消失了。我們從頭再聊一次吧";
translations["MSG_BUILDER_AI_SEND_BTN"] = "傳送";
translations["MSG_BUILDER_AI_INPUT_PLACEHOLDER"] = "寫下更多指示";
translations["MSG_BUILDER_AI_COMMANDS_LABEL"] = "使用的命令";
translations["MSG_BUILDER_AI_FLOORS_LABEL"] = "高度";
translations["MSG_BUILDER_AI_FLOOR_UNIT"] = "層";
translations["MSG_BUILDER_AI_RESET"] = "重新開始";
// 拼圖編輯器: BuilderTutorialOverlay (spec §5.8.6)
translations["MSG_BUILDER_TUTORIAL_STEP1_TITLE"] = "放置角色吧！";
translations["MSG_BUILDER_TUTORIAL_STEP1_DESC"] = "把下面的角色放到地圖上";
translations["MSG_BUILDER_TUTORIAL_STEP2_TITLE"] = "放置終點吧！";
translations["MSG_BUILDER_TUTORIAL_STEP2_DESC"] = "接下來放置終點旗幟";
translations["MSG_BUILDER_TUTORIAL_STEP3_TITLE"] = "排列積木吧！";
translations["MSG_BUILDER_TUTORIAL_STEP3_DESC"] = "放置道路和植物來製作地圖";
translations["MSG_BUILDER_TUTORIAL_STEP4_TITLE"] = "用測試動起來！";
translations["MSG_BUILDER_TUTORIAL_STEP4_DESC"] = "放好角色和終點後，就能用上方的測試來玩";
translations["MSG_BUILDER_GUIDE_REPLAY"] = "再看一次引導";
translations["MSG_BUILDER_TUTORIAL_STEP5_TITLE"] = "公開吧！";
translations["MSG_BUILDER_TUTORIAL_STEP5_DESC"] = "用「完成準備」面板公開吧";
translations["MSG_BUILDER_TUTORIAL_SKIP"] = "稍後查看";
translations["MSG_BUILDER_TUTORIAL_NEXT"] = "下一步";
translations["MSG_BUILDER_TUTORIAL_DONE"] = "開始";
translations["MSG_BUILDER_TOP_GUIDE_BTN"] = "使用方法";
translations["MSG_BUILDER_GUIDEBOOK_TITLE"] = "使用方法";
translations["MSG_BUILDER_GUIDEBOOK_PREV"] = "上一頁";
translations["MSG_BUILDER_GUIDEBOOK_NEXT"] = "下一頁";
translations["MSG_BUILDER_GUIDEBOOK_DONE"] = "關閉";
translations["MSG_BUILDER_GUIDEBOOK_PAGE"] = "%{current} / %{total}";
translations["MSG_BUILDER_GUIDEBOOK_CH_MINE"] = "我的拼圖";
translations["MSG_BUILDER_GUIDEBOOK_CH_PUBLIC"] = "大家的拼圖";
translations["MSG_BUILDER_GUIDEBOOK_CH_DETAIL"] = "拼圖詳情";
translations["MSG_BUILDER_GUIDEBOOK_CH_TRASH"] = "回收筒";
translations["MSG_BUILDER_GUIDEBOOK_MINE_OVERVIEW_TITLE"] = "我的拼圖頁面";
translations["MSG_BUILDER_GUIDEBOOK_MINE_OVERVIEW_DESC"] =
  "你做的拼圖都排列在這裡\n左邊可以改變尋找方式\n右邊可以切換到其他頁面";
translations["MSG_BUILDER_GUIDEBOOK_MINE_GUIDE_TITLE"] = "使用方法按鈕";
translations["MSG_BUILDER_GUIDEBOOK_MINE_GUIDE_DESC"] =
  "在畫面的右上角\n迷路時按一下，就會出現這本手冊";
translations["MSG_BUILDER_GUIDEBOOK_MINE_CARD_TITLE"] = "拼圖卡片";
translations["MSG_BUILDER_GUIDEBOOK_MINE_CARD_DESC"] =
  "一張卡片就是一個拼圖\n上面是名字和作者\n中間是地圖的樣子";
translations["MSG_BUILDER_GUIDEBOOK_MINE_STATS_TITLE"] = "卡片上的數字";
translations["MSG_BUILDER_GUIDEBOOK_MINE_STATS_DESC"] =
  "從左邊開始：被看的次數、點讚數\n然後是被玩的次數\n公開之後就會增加";
translations["MSG_BUILDER_GUIDEBOOK_MINE_ACTIONS_TITLE"] = "卡片的四個按鈕";
translations["MSG_BUILDER_GUIDEBOOK_MINE_ACTIONS_DESC"] =
  "從左邊開始：切換公開、玩一玩\n編輯、打開詳情";
translations["MSG_BUILDER_GUIDEBOOK_MINE_FILTER_TITLE"] = "篩選";
translations["MSG_BUILDER_GUIDEBOOK_MINE_FILTER_DESC"] =
  "用「公開」可以只顯示已公開的拼圖\n「其他」可以按照用AI做的拼圖等條件來篩選";
translations["MSG_BUILDER_GUIDEBOOK_MINE_SORT_TITLE"] = "排序與顯示";
translations["MSG_BUILDER_GUIDEBOOK_MINE_SORT_DESC"] =
  "用排序改變順序\n用顯示選擇一列還是兩列\n做得多了以後會很方便";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TABS_TITLE"] = "右邊的標籤";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TABS_DESC"] = "點「大家的拼圖」\n可以看到別人公開的拼圖";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TRASH_TITLE"] = "去回收筒";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TRASH_DESC"] =
  "這個按鈕可以查看丟掉的拼圖\n不小心丟掉了，也可以從這裡找回來";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_OVERVIEW_TITLE"] = "大家的拼圖頁面";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_OVERVIEW_DESC"] =
  "這裡排列著別人公開的拼圖\n可以隨便玩，喜歡的話請按讚";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_ACTIONS_TITLE"] = "卡片的三個按鈕";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_ACTIONS_DESC"] =
  "從左邊開始：玩一玩、複製來做\n打開詳情";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_FILTER_TITLE"] = "按種類篩選";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_FILTER_DESC"] =
  "用「種類」可以選擇地圖的類型\n想找自己喜歡的拼圖時可以用";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_SORT_TITLE"] = "按人氣排序";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_SORT_DESC"] =
  "選擇點讚後\n點讚多的拼圖會排在前面\n也可以按最新排序";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OVERVIEW_TITLE"] = "詳情頁面";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OVERVIEW_DESC"] =
  "這裡可以看到拼圖的全部內容\n可以先確認是什麼樣的地圖再玩";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_TABS_TITLE"] = "四個標籤";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_TABS_DESC"] =
  "詳情、指令、排行榜、評論\n點一下就能切換\n在指令裡能看到可以使用的命令";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_INFO_TITLE"] = "說明與提示";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_INFO_DESC"] =
  "這是作者寫的說明\n下面有表達感想的圖示，以及卡住時可以看的提示";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REACTION_TITLE"] = "表情反應";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REACTION_DESC"] =
  "可以用這些圖示表達玩過之後的感想\n點一下就會傳給作者";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_ACTIONS_TITLE"] = "下面的按鈕";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_ACTIONS_DESC"] =
  "點玩一玩就能馬上開始\n用複製來做可以變成自己的拼圖";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REPORT_TITLE"] = "檢舉";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REPORT_DESC"] =
  "如果看到讓你不舒服的拼圖\n請從這裡告訴我們\n會有大人來確認";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OWN_TITLE"] = "自己的拼圖時";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OWN_DESC"] =
  "打開自己的拼圖時，按鈕會不一樣\n可以「編輯」，也可以切換公開";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_SEND_TITLE"] = "放進回收筒";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_SEND_DESC"] =
  "不需要的拼圖可以放進回收站\n從詳情頁面放進去\n並不會馬上消失";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_OVERVIEW_TITLE"] = "回收筒裡面";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_OVERVIEW_DESC"] =
  "放進回收筒的拼圖會排列在這裡\n還在這裡的時候都可以找回來";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_RESTORE_TITLE"] = "還原或徹底刪除";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_RESTORE_DESC"] =
  "綠色按鈕可以還原\n紅色按鈕會徹底刪除\n刪除後就找不回來了";
translations["MSG_BUILDER_GUIDEBOOK_CH_SCREEN"] = "畫面說明";
translations["MSG_BUILDER_GUIDEBOOK_CH_BUILD"] = "製作地圖";
translations["MSG_BUILDER_GUIDEBOOK_CH_SETTING"] = "拼圖設定";
translations["MSG_BUILDER_GUIDEBOOK_CH_PUBLISH"] = "測試與公開";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_OVERVIEW_TITLE"] = "編輯畫面";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_OVERVIEW_DESC"] =
  "在中間製作地圖\n周圍有四個區域\n各有各的作用";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_HEADER_TITLE"] = "上面的工具列";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_HEADER_DESC"] =
  "左邊是拼圖的名字\n右邊是詳情、大小、指令\n自動生成、測試、幫助";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_STEPS_TITLE"] = "左邊的面板";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_STEPS_DESC"] =
  "這裡列出了公開之前要做的事\n按順序完成後，最後就可以公開了";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_TOOLS_TITLE"] = "右邊的工具";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_TOOLS_DESC"] =
  "做錯了可以復原\n改變方塊的放置方式\n改變地圖的顯示方式";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_ASSETS_TITLE"] = "下面的工具列";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_ASSETS_DESC"] =
  "這裡排列著可以放置的方塊和角色\n從這裡選好後放到地圖上";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_BACK_TITLE"] = "返回";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_BACK_DESC"] =
  "回到拼圖列表\n做好的內容會自動保存\n請放心";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_BLOCKS_TITLE"] = "選擇並放置";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_BLOCKS_DESC"] =
  "在下面的工具列選擇方塊\n點地圖就能放置\n同樣的方塊可以放很多個";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_OPEN_TITLE"] = "打開列表";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_OPEN_DESC"] =
  "這個按鈕在下面工具列的最右邊\n按一下就能看到所有可以使用的方塊";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_LIST_TITLE"] = "全部方塊";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_LIST_DESC"] =
  "點「列表」就能看到所有可以使用的方塊\n地面、水等每種類型都有說明";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_TAP_TITLE"] = "放置與橡皮擦";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_TAP_DESC"] =
  "「點擊」是放置模式，「橡皮擦」是刪除模式\n想刪除時先切換到橡皮擦再點";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_UNDO_TITLE"] = "還原與重做";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_UNDO_DESC"] =
  "做錯了也沒關係\n用復原回到上一步\n用重做再往前一步";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_ZOOM_TITLE"] = "改變視角";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_ZOOM_DESC"] =
  "用縮小、放大改變地圖的大小\n用重置把角度和大小恢復原樣";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_HISTORY_TITLE"] = "查看紀錄";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_HISTORY_DESC"] =
  "打開、測試等時候，會保留當時的地圖\n做錯了的時候可以恢復到之前";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_STEPS_TITLE"] = "完成準備";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_STEPS_DESC"] =
  "公開之前有5件事要做\n完成的會打上綠色的勾";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_CHARACTER_TITLE"] = "角色與終點";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_CHARACTER_DESC"] =
  "放一個出發的角色\n放一個要到達的終點\n缺了任何一個都不能測試";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_COMMANDS_TITLE"] = "可用的指令";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_COMMANDS_DESC"] =
  "選擇玩的人可以使用的命令\n也可以設定次數\n次數越少地圖越難";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_SIZE_TITLE"] = "地圖大小";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_SIZE_DESC"] =
  "可以改變地圖的大小\n變大之後能放更多東西\n不過難度也會提高";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_AI_TITLE"] = "讓AI來做";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_AI_DESC"] =
  "先選好難度\nAI會給出幾個地圖方案\n挑一個喜歡的再自己修改";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_INFO_TITLE"] = "拼圖資訊";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_INFO_DESC"] =
  "在這裡決定名字、說明和封面圖\n這是玩的人最先看到的地方";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_TEST_TITLE"] = "測試";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_TEST_DESC"] =
  "這個按鈕可以玩自己的地圖來確認\n過不了關的地圖不能公開";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PLAY_TITLE"] = "測試畫面";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PLAY_DESC"] =
  "這和玩的人看到的畫面一樣\n在這裡確認能不能到達終點";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_COMMANDS_TITLE"] = "排列指令";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_COMMANDS_DESC"] =
  "把左邊的命令拖出來連起來\n「剩餘」表示還能用幾次";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_START_TITLE"] = "開始";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_START_DESC"] =
  "角色會按照排好的指令行動\n到達終點就算過關";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_STEP_TITLE"] = "測試步驟";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_STEP_DESC"] =
  "通過測試後，這裡會打上勾\n修改地圖之後需要重新測試";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PUBLISH_TITLE"] = "向大家公開";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PUBLISH_DESC"] =
  "5項準備全部完成後就能按了\n公開之後，拼圖會出現在大家的拼圖裡";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_HELP_TITLE"] = "遇到困難就看說明";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_HELP_DESC"] =
  "隨時都可以打開這本手冊\n每個畫面也有各自的幫助\n只說明那個地方";
translations["MSG_BUILDER_TOP_GUIDE_CLOSE"] = "關閉";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP1_TITLE"] = "我的拼圖";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP1_DESC"] = "這裡會顯示你自己製作的拼圖。";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP2_TITLE"] = "打開拼圖";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP2_DESC"] = "點擊卡片即可查看拼圖的詳細內容。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP1_TITLE"] = "大家的拼圖";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP1_DESC"] = "可以玩其他人公開的拼圖。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP2_TITLE"] = "尋找拼圖";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP2_DESC"] = "點擊卡片，找到你喜歡的拼圖。";
translations["MSG_BUILDER_TOP_GUIDE_TRASH_STEP1_TITLE"] = "垃圾箱";
translations["MSG_BUILDER_TOP_GUIDE_TRASH_STEP1_DESC"] = "刪除的拼圖會放在這裡。也可以還原。";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP1_TITLE"] = "拼圖資訊";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP1_DESC"] =
  "用上方的應用代碼，可以把拼圖分享給朋友。";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP2_TITLE"] = "編輯與公開";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP2_DESC"] = "可以在這裡修改拼圖，或公開給大家。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP1_TITLE"] = "玩這個拼圖";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP1_DESC"] = "可以查看其他人拼圖的內容。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP2_TITLE"] = "收藏與檢舉";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP2_DESC"] = "喜歡就點愛心，有問題可以檢舉。";
translations["MSG_BUILDER_COMMAND_BTN"] = "命令";
translations["MSG_BUILDER_HELP_BTN"] = "說明";
// ピースビルダー: 画面ごとのヘルプ説明（BuilderHelpPopup）
translations["MSG_BUILDER_HELP_AI_TITLE"] = "用AI製作";
translations["MSG_BUILDER_HELP_ASSET_TITLE"] = "選擇方塊";
translations["MSG_BUILDER_HELP_HISTORY_TITLE"] = "查看紀錄";
translations["MSG_BUILDER_STEP_NEED_GROUND"] = "需要先放置地面";
translations["MSG_BUILDER_COMMENT_GUEST"] = "完成監護設定後\n就可以留言";
translations["MSG_BUILDER_COMMENT_BLOCKED"] = "家長把留言關掉了";
translations["MSG_BUILDER_COMMENT_OFF"] = "這個拼圖的留言是關著的";
translations["MSG_BUILDER_COMMENT_UNPUBLISHED"] = "公開後就可以收到留言";
translations["MSG_BUILDER_COMMENT_DENIED"] = "現在不能留言";
translations["MSG_BUILDER_COMMENT_BANNED_WORD"] = "裡面有不能使用的詞語，請重新寫一次";
translations["MSG_BUILDER_STEP_PLACE_GROUND_FIRST"] = "請先放置地面";
translations["MSG_BUILDER_PLACE_ON_GROUND"] = "請放在地面上";
translations["MSG_BUILDER_PLACE_ON_TILE"] = "請放在地圖的方格上";
translations["MSG_BUILDER_ONLY_ONE_CHARACTER"] = "角色只能放一個";
translations["MSG_BUILDER_ONLY_ONE_GOAL"] = "終點只能放一個";
translations["MSG_BUILDER_HELP_PUBLISH_GROUND_TITLE"] = "先放地面";
translations["MSG_BUILDER_HELP_PUBLISH_GROUND_DESC"] =
  "角色和終點要放在地面上\n沒有地面就放不了\n按「放置」就能選地面";
translations["MSG_BUILDER_HELP_PUBLISH_TITLE"] = "發佈你的拼圖";
translations["MSG_BUILDER_HELP_DETAIL_TABS_TITLE"] = "四個標籤";
translations["MSG_BUILDER_HELP_DETAIL_TABS_DESC"] = "詳情、指令、排行榜、留言\n點一下切換";
translations["MSG_BUILDER_HELP_DETAIL_NAME_TITLE"] = "名稱與說明";
translations["MSG_BUILDER_HELP_DETAIL_NAME_DESC"] = "用「修改」編輯\n這是玩的人最先看到的地方";
translations["MSG_BUILDER_HELP_DETAIL_COVER_TITLE"] = "封面與背景";
translations["MSG_BUILDER_HELP_DETAIL_COVER_DESC"] = "封面：列表裡顯示的圖\n背景：玩的時候的景色";
translations["MSG_BUILDER_HELP_AI_LEVEL_TITLE"] = "難度";
translations["MSG_BUILDER_HELP_AI_LEVEL_DESC"] = "星星越多越難";
translations["MSG_BUILDER_HELP_AI_FLOOR_TITLE"] = "高度";
translations["MSG_BUILDER_HELP_AI_FLOOR_DESC"] = "地圖的層數\n層數越多越立體";
translations["MSG_BUILDER_HELP_AI_CREATE_TITLE"] = "產生";
translations["MSG_BUILDER_HELP_AI_CREATE_DESC"] =
  "會產生3個方案\n點一下可以放大確認\n可以反覆重新產生";
translations["MSG_BUILDER_HELP_ASSET_ALL_TITLE"] = "方塊一覽";
translations["MSG_BUILDER_HELP_ASSET_ALL_DESC"] = "所有可以使用的方塊";
translations["MSG_BUILDER_HELP_ASSET_KIND_TITLE"] = "種類";
translations["MSG_BUILDER_HELP_ASSET_KIND_DESC"] = "地面、水、裝飾、道具\n按種類分組";
translations["MSG_BUILDER_HELP_ASSET_PICK_TITLE"] = "選擇並放置";
translations["MSG_BUILDER_HELP_ASSET_PICK_DESC"] = "點一下選擇\n再點地圖就能放置";
translations["MSG_BUILDER_HELP_HISTORY_ALL_TITLE"] = "查看紀錄";
translations["MSG_BUILDER_HELP_HISTORY_ALL_DESC"] =
  "按最新順序排列\n每筆紀錄下面是這期間做過的操作";
translations["MSG_BUILDER_HELP_HISTORY_ITEM_TITLE"] = "一筆紀錄";
translations["MSG_BUILDER_HELP_HISTORY_ITEM_DESC"] = "是什麼時候的地圖，比如打開或測試時";
translations["MSG_BUILDER_HELP_HISTORY_UNDO_TITLE"] = "還原";
translations["MSG_BUILDER_HELP_HISTORY_UNDO_DESC"] = "可以恢復到當時的地圖\n恢復之後還能繼續做";
translations["MSG_BUILDER_HELP_PUBLISH_STEPS_TITLE"] = "完成準備";
translations["MSG_BUILDER_HELP_PUBLISH_STEPS_DESC"] = "公開之前要做的5件事";
translations["MSG_BUILDER_HELP_PUBLISH_CHECK_TITLE"] = "打勾";
translations["MSG_BUILDER_HELP_PUBLISH_CHECK_DESC"] = "完成後會打上綠色的勾";
translations["MSG_BUILDER_HELP_PUBLISH_GO_TITLE"] = "向大家公開";
translations["MSG_BUILDER_HELP_PUBLISH_GO_DESC"] = "5項都完成後就能按\n會出現在大家的拼圖裡";
translations["MSG_BUILDER_HELP_DETAIL_TITLE"] = "拼圖資訊";
translations["MSG_BUILDER_SIZE_MODAL_TITLE"] = "選擇大小";
translations["MSG_BUILDER_SIZE_SHRINK_WARNING"] = "縮小後，超出範圍的%{count}個會被刪除";
// 拼圖編輯器: PiecePreview (spec §5.7)
translations["MSG_BUILDER_PREVIEW_RUN"] = "執行";
translations["MSG_BUILDER_PREVIEW_RESET"] = "重置";
translations["MSG_BUILDER_PREVIEW_MOVES"] = "步數";
translations["MSG_BUILDER_PREVIEW_TIME"] = "時間";
translations["MSG_BUILDER_PREVIEW_BLOCK_DISABLED"] = "這個拼圖裡不能用喔";
translations["MSG_BUILDER_PREVIEW_CLEAR"] = "通關！";
translations["MSG_BUILDER_PREVIEW_BACK"] = "退出";
translations["MSG_BUILDER_SAVED"] = "已儲存";
translations["MSG_CHAT_NEW_BADGE"] = "New";
translations["MSG_CHAT_LOAD_MORE"] = "查看更多";
translations["MSG_DASHBOARD_MAIL_EMPTY"] = "還沒有郵件";
translations["MSG_DASHBOARD_MAIL_IMAGE"] = "照片";
translations["MSG_DASHBOARD_MAIL_PROJECT"] = "項目";
translations["MSG_DASHBOARD_MAIL_COURSE_CLEAR"] = "課程通關";

translations["MSG_CHAT_SEND_FAILED_MESSAGE"] = "傳送訊息失敗";

translations["MSG_CREATOR_DEFAULT_CHECK_APP"] = "查看\n應用";
translations["MSG_CREATOR_DEFAULT_CREATE_APP"] = "建立應用";
translations["MSG_CREATOR_DEFAULT_SEARCH_APP"] = "搜尋應用";

translations["MSG_SUBSCRIPTION_ASK_PARENT_BTN"] = "請家長幫忙";
translations["MSG_SUBSCRIPTION_ASK_PARENT_SENT_LABEL"] = "已發送";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_TITLE"] = "請家長幫忙";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_WITH_PLAN"] = "要向家長請求「%{plan}」嗎？";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_NO_PLAN"] = "要向家長發送方案請求嗎？";
translations["MSG_SUBSCRIPTION_ASK_PARENT_SEND_BTN"] = "發送";
translations["MSG_SUBSCRIPTION_ASK_PARENT_CANCEL_BTN"] = "取消";
translations["MSG_SUBSCRIPTION_ASK_PARENT_TOAST_SUCCESS"] = "已發送請求。";
translations["MSG_SUBSCRIPTION_ASK_PARENT_TOAST_ERROR"] = "發送失敗。請重試。";
translations["MSG_SUBSCRIPTION_REQUEST_CARD_CHILD_STATUS"] = "已向家長發送方案請求。";

export default translations;
